import { sentenceCase } from 'change-case'
// material
import { experimentalStyled as styled, alpha } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import {
  Box,
  Card,
  Grid,
  Typography,
  Stack,
  CircularProgress,
  Button,
  Checkbox,
  makeStyles,
  Slider as Sliderw,
  TextField,
  InputAdornment,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  useMediaQuery,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Slide,
  Autocomplete,
  Skeleton,
} from '@material-ui/core'
import {
  Groups,
  Attachment,
  ChatBubble,
  DeleteOutlineOutlined,
  Logout,
  Login,
  CheckBoxRounded,
  AccessTime,
  LocationOn,
  Search,
  Visibility,
  QrCodeScanner,
  PictureAsPdf,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Close,
} from '@material-ui/icons'
//

import Label from 'src/components/Label'
import SubTaskMeterChart from 'src/components/SubTaskMeterChart'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { useState, useEffect, useRef, useMemo, forwardRef } from 'react'
import ConfirmationPopup from 'src/components/confirmationPopup'
import WarningMaterialPopup from 'src/components/WarningMaterialPopup'
import ProjectViewList from 'src/components/_dashboard/blog/ProjectViewList.js'
import ProjectViewGridList from 'src/components/_dashboard/blog/ProjectViewGridList'
import { BASE_URL, currentFacilityId, REST_API_END_POINT, FacilityTypes, UNITS } from 'src/constants/Defaultvalues'
import axios from 'axios'
import { useSnackbar } from 'notistack'
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu'
import moment from 'moment'
import { UserMoreMenu } from 'src/components/_dashboard/user/list'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import { StaticDatePicker } from '@material-ui/lab'
import QrReader from 'react-qr-reader';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { isAdminUser } from '../../../utils/adminUserTypes';
import { DialogAnimate } from 'src/components/animate'
import { Icon } from '@iconify/react'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import editFill from '@iconify/icons-eva/edit-fill';

const option = [
  { id: 6, color: 'error', value: 'Inactive' },
  { id: 1, color: 'primary', value: 'New' },
  { id: 2, color: 'info', value: 'In Progress' },
  { id: 3, color: 'success', value: 'Completed' },
  { id: 4, color: 'success', value: 'Received' },
  { id: 5, color: 'success', value: 'Active' },
  // { id: 9, color: 'error', value: 'Rejected' },
  // { id: 6, color:'success', value: 'Approved by Dev team' },
  // { id: 7, color:'success', value: 'Approved by the client' },
  // { id: 8, color:'primary', value: 'Reopen' },
]

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  cursor: 'pointer',
  paddingTop: 'calc(100% * 8 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    pointerEvents: 'none',
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  // background: `url(${src}) center/cover no-repeat`
})

function ProjectStatusPopup({ open, onClose, staffTimeLogData, handleClockInOut, autoClockoutTime }) {
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [timerId]);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        handleClockInOut();
      }, autoClockoutTime * 60 * 1000);

      setTimerId(timer);
    } else {
      if (timerId) {
        clearTimeout(timerId);
      }
    }
  }, [open]);
 
  return (
      <Dialog  onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose(false);
        }
      }}>
          <DialogTitle>Are you still working on this project?</DialogTitle>
          <DialogContent>
              <DialogContentText sx={{mt:3}}>
                  Do you want to continue working on "{staffTimeLogData?.task_name}" in "{staffTimeLogData?.project_name}"?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button variant='contained' onClick={() => { clearTimeout(timerId); onClose(true); }}>
                  Yes
              </Button>
              <Button variant='outlined' onClick={() => { clearTimeout(timerId); onClose(false); }}>
                  No
              </Button>
          </DialogActions>
      </Dialog>
  );
}
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const getDeliveryTypeText = (typeId) => {
  const deliveryTypes = {
    1: "Install",
    2: "Pickup",
    3: "Shipping",
  };

  return deliveryTypes[Number(typeId)] || "";
};

/** Build stack groups for bundle tasks.
 * - If `parent_task_id` points to an existing task row, that task is the root.
 * - If parent task row is skipped (fallback stores parent product id), group siblings by that id and use the first sibling as the visual root.
 */
function buildTaskListWithBundleStacks(tasks) {
  if (!Array.isArray(tasks) || tasks.length === 0) return []
  const byId = new Map()
  for (const t of tasks) {
    const id = t.ID ?? t.id
    if (id != null && id !== '') byId.set(Number(id), t)
  }
  const childrenByParentTask = new Map()
  const childrenByParentProduct = new Map()
  const groupedChildIds = new Set()

  for (const t of tasks) {
    const taskId = Number(t.ID ?? t.id)
    const rawPid = t.parent_task_id ?? t.parentTaskId
    if (rawPid == null || rawPid === '') continue
    const pid = Number(rawPid)
    if (Number.isNaN(pid)) continue
    if (byId.has(pid)) {
      if (!childrenByParentTask.has(pid)) childrenByParentTask.set(pid, [])
      childrenByParentTask.get(pid).push(t)
      groupedChildIds.add(taskId)
    } else {
      if (!childrenByParentProduct.has(pid)) childrenByParentProduct.set(pid, [])
      childrenByParentProduct.get(pid).push(t)
      groupedChildIds.add(taskId)
    }
  }

  for (const arr of childrenByParentTask.values()) {
    arr.sort(
      (a, b) =>
        Number(a.order_id ?? 0) - Number(b.order_id ?? 0) ||
        Number(a.ID ?? a.id ?? 0) - Number(b.ID ?? b.id ?? 0),
    )
  }

  const orphanRootExtras = new Map()
  for (const arr of childrenByParentProduct.values()) {
    arr.sort(
      (a, b) =>
        Number(a.order_id ?? 0) - Number(b.order_id ?? 0) ||
        Number(a.ID ?? a.id ?? 0) - Number(b.ID ?? b.id ?? 0),
    )
    if (arr.length === 0) continue
    const root = arr[0]
    const rootId = Number(root.ID ?? root.id)
    groupedChildIds.delete(rootId)
    orphanRootExtras.set(rootId, arr.slice(1))
  }

  const roots = tasks.filter((t) => !groupedChildIds.has(Number(t.ID ?? t.id)))

  return roots.map((parent) => {
    const pid = Number(parent.ID ?? parent.id)
    const fromTaskParent = childrenByParentTask.get(pid) || []
    const fromProductParent = orphanRootExtras.get(pid) || []
    const kids = [...fromTaskParent, ...fromProductParent]
    const linked_tasks = kids.map((child) => ({ ...child, ID: child.ID ?? child.id }))
    return { ...parent, linked_tasks }
  })
}

export default function Tasks({
  isEstimateJob,
  subtaskcount,
  isTimeAndMaterial,
  designs,
  details,
  setFetchData,
  valueTab,
  data,
  projectId,
  currentTab,
  popupOn,
  setProjectsId,
  setPostId,
  handleinnerTask,
  setTaskdetails,
  setTaskCurrentTab,
  onDataChange,
  refresh,
  setRefresh,
  projectMembers,
  isMirrored,
  requestStatus,
}) {
  const displayTasks = useMemo(() => buildTaskListWithBundleStacks(data || []), [data])
  console.log('details--------data', data)
  console.log('detailsdata details', details)
  const isSalesOrderVoided = Number(requestStatus) === 10
  const canModifyTasks = details?.hold != 1 && !isSalesOrderVoided
  const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const blockTaskAccessIfVoided = () => {
    if (!isSalesOrderVoided) return false
    enqueueSnackbar('Cannot access this task while the sales order is voided', { variant: 'warning' })
    return true
  }
  const [isHover, setIsHover] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [deleteStates, setDeleteStates] = useState({})
  const [taskId, setTaskId] = useState(null)
  const [materialData, setMaterialData] = useState(null)
  const [staffTimeLog, setStaffTimeLog] = useState(null)
  const [openPopup, setOpenPopup] = useState(false)
  const [searchMaterial, setSearchMaterial] = useState('')
  const [qty, setQty] = useState(1);
  const [viewMaterialData, setViewMaterialData] = useState([])
  const [viewMaterial, setViewMaterial] = useState(false)
  const [loadingMaterials, setLoadingMaterials] = useState(false)
  const [elapsedTime, setElapsedTime] = useState(0)
  const [checkedItems, setCheckedItems] = useState([])
  console.log('checkedItemssss', checkedItems)
  const [popUpTime, setPopUpTime] = useState(0)
  const [autoClockoutTime, setAutoClockoutTime] = useState(0)
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [confirmAdditionalJObCost, setConfirmAdditionalJObCost] =
    useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [warningMaterialPopup, setWarningMaterialPopup] = useState(false)
  const [warningMaterialData, setWarningMaterialData] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [openPopupComplete, setOpenPopupComplete] = useState(false)
      const [completeStatus, setCompleteStatus] = useState(1)
      const [finalTaskId, setFinalTaskId] = useState(null);
    const [finalTaskStatus, setFinalTaskStatus] = useState(null);
    const [clockInServices,setclockInServices] = useState([])
    const [openService, setOpenService] = useState(false)
    const [loading2,setLoading2] = useState(false)
    const [selectedService, setSelectedService] = useState(null);
    const [subTaskMembers,setSubTaskMembers] = useState(projectMembers || [])
    console.log('subTaskMemberssssss', subTaskMembers)
    const [clockInInputs, setClockInInputs] = useState([]);
    const [subTaskId, setSubTaskId] = useState(null);
    const [openServiceWorkflowConfirmation, setOpenServiceWorkflowConfirmation] = useState(false);
    const [selectedTaskForCompletion, setSelectedTaskForCompletion] = useState(null);
    const [selectedPDF, setSelectedPDF] = useState(null);
    const [openPDFModal, setOpenPDFModal] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(true);
    const [useOfficeViewer, setUseOfficeViewer] = useState(true);
    const [bundleStackModalPost, setBundleStackModalPost] = useState(null)
    const [addPartialStock, setAddPartialStock] = useState(false);
    const [partialModalOpen, setPartialModalOpen] = useState(false);
    const [openPartialConfirm, setOpenPartialConfirm] = useState(false);
    const [partialTargetProduct, setPartialTargetProduct] = useState(null);
    const [movingQty, setMovingQty] = useState(1);
    const [partialSize, setPartialSize] = useState('');
    const [convertionUnit, setConvertionUnit] = useState(null);
    const [convertionUnitName, setConvertionUnitName] = useState(null);
    const [unitType, setUnitType] = useState(null);
    const [convertionQty, setConvertionQty] = useState(0);
    const [convertionUnitPrice, setConvertionUnitPrice] = useState(0);
    const [convertionTotalPrice, setConvertionTotalPrice] = useState(0);
    const [autoFill, setAutoFill] = useState(true);
    const [partialErrors, setPartialErrors] = useState({});
    const [partialCondition, setPartialCondition] = useState(false);    const [futureInstallations, setFutureInstallations] = useState([]);
    const [existingJobCostData, setExistingJobCostData] = useState(null);
    const [selectedInstallation, setSelectedInstallation] = useState(null);
    const [retryFirstApiCall, setRetryFirstApiCall] = useState(false);

  // const filteredClockInServices = [
  //   ...clockInServices?.filter((item) => item.labour_cost_service_id !== 10),
  //   clockInServices?.find((item) => item.labour_cost_service_id === 10)
  // ].filter(Boolean);


  const isClockInDisabled = subTaskMembers.every((member) => {
    const entry = clockInInputs.find((e) => e.staff_id === member.staff_id);
    const hasHour = entry?.hour > 0;
    // const hasService = entry?.service_id && entry?.service_id !== '';
    return !(hasHour);
  });
  
  const checkedTaskDetails = data?.filter((item) =>
    checkedItems.includes(String(item.ID))
  );

  console.log('checkedTaskDetails', checkedTaskDetails)
  const setServiceDetails = () => {
    if (checkedTaskDetails?.[0]?.service_id != null) {
      setSelectedService(checkedTaskDetails[0].rs_id);
    }
  };

  const filteredClockInServices = clockInServices?.filter(item => {
    if (checkedTaskDetails?.[0]?.service_id == null) {
      return !!item.recipe_id;
    }
    return true;
  }) || [];

  console.log('filteredClockInServices--clockInServices', clockInServices)
  console.log('filteredClockInServices--clockInServices--1', clockInServices.find((s) => s.labour_cost_service_id == 10)?.id)
  console.log('filteredClockInServices', filteredClockInServices)
  console.log('filteredClockInServices data', data)
  console.log('filteredClockInServices checkedItems', checkedItems)

useEffect(() => {
  if (checkedTaskDetails?.length > 0) {
    setServiceDetails();
  }
}, [checkedTaskDetails]);
console.log('checkedTaskDetails', checkedTaskDetails)
   
  const handleClockinTime = () => {
    try {
      console.log('ghhhhhhf')
      setSubTaskMembers(projectMembers)
      setOpenService(true)
    } catch (error) {
      console.log('error', error)
    }
  }

  console.log('details Tab value-------', details)
  const user = JSON.parse(window.localStorage.getItem('user'))
  const explodedPermissions = user?.exploded_permissions
  const SchedulePermission = explodedPermissions?.some((permission) => ['Schedule Install'].includes(permission)) ? true : false
  const hasJobCostPermission = explodedPermissions?.some((permission) => ['Manage Job Cost'].includes(permission)) ? true : false
  const userId = user?.user_id
  let userType = user.user_type
  const isClient = user?.isClient;

  // Helper function to check if URL is a PDF
  const isPdfUrl = (url, fileType = '', extension = '') => {
    if (!url) return false;
    const ft = String(fileType || '').toLowerCase();
    const ext = String(extension || '').toLowerCase();
    return (
      url.toLowerCase().includes('.pdf') ||
      url.toLowerCase().includes('application/pdf') ||
      ft === 'application/pdf' ||
      ft === 'pdf' ||
      ext === 'pdf'
    );
  }
  const DESIGN_PREVIEW_EXTENSIONS = ['eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps', 'indd', 'indt', 'x-eps', 'x-ai', 'postscript'];
  const getFileExtensionFromUrl = (url) => {
    if (!url) return '';
    const clean = url.split('?')[0];
    return clean.includes('.') ? clean.split('.').pop().toLowerCase() : '';
  };
  const isGoogleViewerDesignUrl = (url, fileType = '', extension = '') => {
    const extFromUrl = getFileExtensionFromUrl(url);
    const ext = String(extension || '').toLowerCase();
    const ft = String(fileType || '').toLowerCase();
    const mimeSubtype = ft.includes('/') ? ft.split('/').pop() : ft;
    return (
      DESIGN_PREVIEW_EXTENSIONS.includes(extFromUrl) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(ext) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(mimeSubtype)
    );
  };
  const [openQRScanner, setOpenQRScanner] = useState(false);
  const scannerRef = useRef(null);
  const [projectData,setProjectData] = useState(null)
  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false)
  const [scheduleTarget, setScheduleTarget] = useState(null)
  const [scheduleDate, setScheduleDate] = useState(() => moment())
  const [scheduleSubmitLoading, setScheduleSubmitLoading] = useState(false)

  const scheduleStaticDatePickerComponents = {
    leftArrowIcon: <KeyboardArrowLeft />,
    rightArrowIcon: <KeyboardArrowRight />,
  }


//   useEffect(()=>{
//     fetchProjectData()
//   },[])

//  const fetchProjectData = async () => {
//   try {
//     const  res = await axios.post(`${REST_API_END_POINT}jobs/get-project-details-by-id`, { projectId: projectId });
//     setProjectData(res?.data?.result[0]);
//     console.log('projectData', res?.data?.result[0])
//   } catch (error) {
//     console.log("error",error)
//     setProjectData(null)
//   }
//  }

    useEffect(() => {
      if (openQRScanner) {
        setTimeout(() => {
          if (!scannerRef.current) {
            scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });
  
            scannerRef.current.render(
              (decodedText) => {
                setSearchMaterial(decodedText);
                handleAddMaterialToJobCost(decodedText); // Automatically update material state
                setOpenQRScanner(false);
              },
              (errorMessage) => {
                console.error("QR Scan Error:", errorMessage);
              }
            );
          }
        }, 500); // Ensure modal is fully rendered before initializing scanner
      }
  
      return () => {
        if (scannerRef.current) {
          scannerRef.current.clear();
          scannerRef.current = null;
        }
      };
    }, [openQRScanner]);


 const handleOpenTask=(postId,project_id,currentTab,details)=>{
  if (blockTaskAccessIfVoided()) return
  console.log('handleOpenTaskData',postId,project_id,currentTab,details)
  setProjectsId(project_id)
  setTaskCurrentTab(currentTab)
  setTaskdetails(details)
  setPostId(postId)
  handleinnerTask()
  console.log('handleOpenTask',postId,project_id,currentTab,details)
 }

  const handleOpenScheduleDialog = (e, post) => {
    e?.stopPropagation?.()
    setScheduleTarget(post)
    setScheduleDate(moment().startOf('day'))
    setScheduleDialogOpen(true)
  }

  const handleCloseScheduleDialog = () => {
    if (scheduleSubmitLoading) return
    setScheduleDialogOpen(false)
    setScheduleTarget(null)
  }

  const handleSubmitTaskSchedule = async () => {
    if (!scheduleTarget) return
    setScheduleSubmitLoading(true)
    try {
      const scheduleTs = scheduleDate.clone().startOf('day').unix()
      const ApiUrl = scheduleTarget?.is_scheduled == 1 ? `${REST_API_END_POINT}project/re-schedule-install` : `${REST_API_END_POINT}project/schedule-install`
      
      const linkedTasksData = (scheduleTarget.linked_tasks || []).map(t => ({
        id: t.ID ?? t.id,
        customer_order_product_id: t.customer_order_product_id || null,
        isProduct: t.product_id ? true : false,
      }))

      const res = await axios.post(ApiUrl, {
        taskId: scheduleTarget.ID,
        scheduleDate: scheduleTs,
        projectId: scheduleTarget.project_id ?? projectId,
        userId: user.user_id,
        completeStatus: scheduleTarget?.service_delivery_type_id || scheduleTarget?.delivery_type_id || 1 ,
        isProduct: scheduleTarget?.product_id ? true : false,
        customer_order_product_id: scheduleTarget?.customer_order_product_id || null,
        linkedTasks: linkedTasksData,
      })
      if (res.data?.status === 1) {
        enqueueSnackbar(res?.data?.message || 'Install scheduled successfully', { variant: 'success' })
        setScheduleDialogOpen(false)
        setScheduleTarget(null)
        setFetchData(true)
      } else {
        enqueueSnackbar(res.data?.message || 'scheduled failed', { variant: 'error' })
      }
    } catch (err) {
      enqueueSnackbar(
        err.response?.data?.message || err.message || 'scheduled failed',
        { variant: 'error' }
      )
    } finally {
      setScheduleSubmitLoading(false)
    }
  }

  const openViewTaskForPost = (post) => {
    if (blockTaskAccessIfVoided()) return
    if (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material')) return
    const tid = post.ID ?? post.id
    const prid = post.project_id
    if (popupOn) {
      handleOpenTask(tid, prid, currentTab, details)
    } else {
      navigate(
        PATH_DASHBOARD.project.viewTask + tid + '/' + prid,
        { state: { currentTab, details, designs } },
      )
    }
  }

  const linkedTaskThumbSrc = (lt) => {
    const thumb = lt?.product_thumbnail
    if (!thumb || thumb === 'default.jpg') return logo
    if (String(thumb).startsWith('http')) return thumb
    const base = String(BASE_URL || '').replace(/\/?$/, '/')
    return `${base}uploads/products/${thumb}`
  }
  const fetchClockSettings = async() => {
    try {
        const res = await axios.post(`${REST_API_END_POINT}settings/fetch-all-clock-settings`,{projectId, taskId})
        if(res.data.status === 1){
            const settingsData = res.data.clocksettings
            setclockInServices(res?.data?.allAddlServices)
            settingsData?.map((item)=>{
              if(item?.id == 1){
                setPopUpTime(parseInt(item?.time))
              }else if(item?.id == 2){
                setAutoClockoutTime(parseInt(item?.time))
              }
            })
        }else{
          
            setPopUpTime(0)
            setAutoClockoutTime(0)
        }
    } catch (error) {
        console.log("Clock settings error : ",error)
        setPopUpTime(0)
        setAutoClockoutTime(0)
    }
  }
 
  useEffect(()=>{
    fetchClockSettings()
  },[checkedItems])

  const logo =
    'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
  const img =
    'https://www.shutterstock.com/image-photo/indianapolis-circa-february-2017-pizza-260nw-572078815.jpg'

  const handleDeleteClick = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: true,
    }))
  }

  const checkReadyForInstallation = async()=>{
    try {
          const  res = await axios.post(`${REST_API_END_POINT}project/check-project-completed`,{projectId,userId})

        if(res?.data?.status===1){
          return res?.data?.allProjectCompleted
        }
    }catch(error){
      console.log('Ready For Installation error : ',error);
    }
  }

  const checkReadyForInstallationDelete = async()=>{
    try {
        const  res = await axios.post(`${REST_API_END_POINT}project/check-project-completed`,{projectId,userId})

        if(res?.data?.status===1){
          const allProjectCompleted = res?.data?.pendingTasks?.length == 0 ? true : false
          return allProjectCompleted
        }
    }catch(error){
      console.log('Ready For Installation error : ',error);
    }
  }
  
  const handleUpdateStatus = async(status, taskId,projectId)=>{
    try {
      const lastInstallationTask = await checkReadyForInstallation()
        console.log(lastInstallationTask ," lastttttttt")
        if (lastInstallationTask) {
          // if(details?.noServiceNoTask == 1){
          if(false){
            setCompleteStatus(1)
            setFinalTaskId(taskId)
            setFinalTaskStatus(status)
            handleFinalUpdateStatus(taskId,status)
          }else{
            convertJObToInstallation ()
            // setOpenPopupComplete(true)
            setFinalTaskId(taskId)
            setFinalTaskStatus(status)
          }
        }else{
      axios.post(`${REST_API_END_POINT}project/update-project-task-status`,{ taskId, status, userId: user.user_id,projectId },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          enqueueSnackbar(response.data.message, { variant: 'success' });
         
        }else if(response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
         if(response.data.allProjectCompleted){
          // setOpenPopupComplete(true)
          }else{
            setFetchData(true)
          }
      }).catch((error) => {
        console.error(error);
      })}
    }catch (error) {
      console.error("Error updating task:", error);
    }
  }

  const handleFinalUpdateStatus = (updatingTaskId,newStatus)=>{
    try {
      axios.post(`${REST_API_END_POINT}project/update-project-task-status`,{ taskId:finalTaskId||updatingTaskId, status:finalTaskStatus||newStatus, userId: user.user_id,projectId,projectCategory: projectData?.project_category || details?.project_category,request_id :projectData?.request_id },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 1){
          enqueueSnackbar(response.data.message, { variant: 'success' });
         
        }else if(response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
         if(response.data.allProjectCompleted){
          convertJObToInstallation()
          }else{
            setFetchData(true)
          }
        
      }).catch((error) => {
        console.error(error);
      })
    }catch (error) {
      console.error("Error updating task:", error);
    }
  }

  const convertJObToInstallation = async(stockData)=>{
    const filteredData = data?.filter(item => item.is_manually_added == 0);
    const apiCompleteStatus = (filteredData?.length > 0 || details?.service_delivery_id || details?.product_delivery_id)
    ? filteredData[0]?.delivery_type_id || filteredData[0]?.service_delivery_type_id || details?.service_delivery_id || details?.product_delivery_id || completeStatus
    : completeStatus;
    console.log('apiCompleteStatus', apiCompleteStatus)
    // Handle "Add to stock" option for no charge projects (category = 13)
    if(Number(completeStatus) === 4 && projectData?.project_category === 13) {
      const res = await axios.post(`${REST_API_END_POINT}installation/complete-job-no-charge`,
        { 
          selectedIds: Number(projectId), 
          userId: userId, 
          completeStatus: Number(completeStatus), 
          clientId: details?.customer_id,
          stockData: stockData || null
        })
      if(res.data.status === 1) {
        setOpenPopupComplete(false);
        enqueueSnackbar('Job completed and stock added successfully', { variant: 'success' });
        setFetchData(true)
      } else {
        enqueueSnackbar("Failed to complete job and add stock", { variant: 'error' });
      }
      return;
    }

    const res = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,
      { selectedIds: Number(projectId), userId: userId,completeStatus:Number(apiCompleteStatus),clientId:details?.customer_id})
      if(res.data.status===1) {
        setOpenPopupComplete(false);
        // enqueueSnackbar(`${details?.noServiceNoTask == 1 ? 'Moved To "No Service No Task"' : Number(completeStatus) === 1
        enqueueSnackbar(`${details?.noServiceNoTask == 1 ? 'Job completed without installation' : Number(apiCompleteStatus) === 1
          ? 'Moved To Installs'
          : Number(apiCompleteStatus) === 2
          ? 'Moved To Pickup'
          : 'Moved To Shipping'} Successfully`, { variant: 'success' });
          // onDataChange()
          setFetchData(true)

      }else{
        enqueueSnackbar("Not Moved To Installation", { variant: 'error' });
      }
  }

  const handleCancelDelete = (postId) => {
    setDeleteStates((prevState) => ({
      ...prevState,
      [postId]: false,
    }))
  }
  const valuetext = (value) => {
    return `${value}%`
  }
  const updateStatus = (event, value) => {
    console.log('###############value', value)
    let values = {}
    let user = JSON.parse(window.localStorage.getItem('user'))
    values.completion = event.target.value
    values.projectId = projectId
    values.added_by = user.user_id
    values.taskId = value
    if (event.target.value && values.projectId) {
      axios.post(
        `${REST_API_END_POINT}project/update-project-task-progress`,
        { ...values },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          // headers: { 'Content-Type': 'multipart/form-data' }
        },
      )
    }
  }
  const handleDeleteTask = async (id, projectId) => {
    console.log(projectId)
    try {
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      const response = await axios
        .post(
          `${REST_API_END_POINT}project/delete-project-task`,
          { id: Number(id), projectId, status: 0, userId },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        
          if (response.data.status === 4) {
            enqueueSnackbar(response.data.message, { variant: 'success' })
            handleCancelDelete(id)
            setFetchData(true)
            // const lastInstallationTask = await checkReadyForInstallationDelete()
            // console.log(lastInstallationTask, " lastttttttt")

            // if (lastInstallationTask) {
            //   setFinalTaskId(id); // optional, if needed later
            //   setFinalTaskStatus(9); // assuming status 3 means "completed"
            //   // setOpenPopupComplete(true)
            // }else{
            //   setFetchData(true)
            //   // handleCancelDelete(id)
            // }
          } else if (response.data.status === 5) {
            enqueueSnackbar(response.data.message, { variant: 'error' })
          }
        
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const fetchTimeLogData = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/fetch-clockedIn-staff-task-timelog`,
        { projectId: projectId, taskId: taskId, userId: userId },
      )
      if (res.data.status === 1) {
        const staffTimeLogData = res.data.result[0]
        let taskIds = staffTimeLogData?.sub_task_id
        taskIds = taskIds?.toString()
        const taskArray = taskIds?.split(',')
        setCheckedItems(taskArray)

        const singleTaskId = taskArray?.length > 0 ? Number(taskArray[0]) : null;
        setTaskId(singleTaskId);
        
        setStaffTimeLog(staffTimeLogData)
        if (staffTimeLogData.end_time === null && staffTimeLogData?.noSubTask == 1) {
          setIsLoggedIn(true)
        } else {
          setIsLoggedIn(false)
        }
      } else {
        setStaffTimeLog(null)
        setIsLoggedIn(false)
        setCheckedItems([])
      }
    } catch (error) {
      console.log('Error fetching : ', error)
    }
  }

  const proceedWithMaterialAddition = async () => {
    try {
      await proceedWithMaterialAdditionFromData(materialData)
    } catch (error) {
      console.log(error)
    }
  }

  const handleConfirmAdditionalJobCost = async () => {
    try {
      if(retryFirstApiCall){
        handleAddMaterialToJobCost(materialData.barcode,2)
        setRetryFirstApiCall(false)
        setConfirmAdditionalJObCost(false)
        setConfirmMessage('')
        setSearchMaterial('')
        setMaterialData(null)
        return;
      }
      // Proceed directly with material addition
      await proceedWithMaterialAddition()
    } catch (error) {
      console.log(error)
    }
  }

  const handleWarningConfirm = async () => {
    try {
      // Use warningMaterialData directly instead of relying on state update
      await proceedWithMaterialAdditionFromData(warningMaterialData)
      setWarningMaterialPopup(false)
      setWarningMaterialData(null)
    } catch (error) {
      console.log(error)
    }
  }

  const handleWarningClose = () => {
    setWarningMaterialPopup(false)
    setWarningMaterialData(null)
    setSearchMaterial('')
    setQty(1)
  }

  const submitJobCostAPI = async (materialDataToUse) => {
    try {
      let realQty = (materialDataToUse?.balanceQty || qty || 1)
      let qtyAddToJob = (materialDataToUse?.ogRemainingQty - materialDataToUse?.movigPartialQty) || 0
      
      let values = [
        {
          productId: materialDataToUse.product_id || materialDataToUse.id,
          projectId: projectId,
          material_id: materialDataToUse?.material_id || null,
          actual_quantity: materialDataToUse.actual_quantity || 0,
          actual_unit_cost: materialDataToUse.actual_unit_cost || 0,
          actual_total: materialDataToUse.actual_total || 0,
          quantity: materialDataToUse.balanceQty ? materialDataToUse.balanceQty : (qty ? qty : 1),
          total: (materialDataToUse.material_unit_cost * qtyAddToJob) || (materialDataToUse.unit_price * qtyAddToJob) || (materialDataToUse.unit_cost * realQty),
          unitPrice: materialDataToUse.material_unit_cost || materialDataToUse.unit_price || materialDataToUse.unit_cost,
          for_product: selectedInstallation?.IsProductInstallation ? selectedInstallation?.location_id : null,
          for_service: selectedInstallation?.IsServiceInstallation ? selectedInstallation?.location_id : null,
          movigPartialQty: materialDataToUse?.movigPartialQty || 0,
          ogRemainingQty: materialDataToUse?.ogRemainingQty || 0,
          qtyAddToJob: qtyAddToJob
        },
      ]
      
      axios
        .post(
          `${REST_API_END_POINT}project/add-job-cost`,
          {
            userId: user.user_id,
            values,
            projectId,
            recipe: 0,
            selectedServices: [],
            scanQr: true,
            taskId,            
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          if (response.data.status === 1) {
            onDataChange()
            enqueueSnackbar(response.data.message, { variant: 'success' })
          } else if (response?.data?.message) {
            enqueueSnackbar(response.data.message, { variant: 'error' })
          } else {
            enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
          }
          setConfirmAdditionalJObCost(false)
          setConfirmMessage('')
          setSearchMaterial('')
        })
        .catch((error) => {
          console.error('Error adding Jobcost', error)
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
        })
    } catch (error) {
      console.log(error)
    }
  }

  const proceedWithMaterialAdditionFromData = async (materialDataToUse) => {
    try {
      if (addPartialStock) {
        
        let maxremQty = 0;
        let maxQty = 1;
        let qtyForPrice = 1;
        let unit_price = 1;
        if(materialDataToUse?.partial==1){
          // maxremQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0);
          // maxQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0)- qty;
           maxremQty = Number(materialDataToUse?.qty ?? materialDataToUse?.quantity ?? 0)- qty;
          // maxremQty = Number(qty);

           // maxQty = Number(qty) - 1;
          maxQty = maxremQty;
          // maxQty = maxremQty - qty;
          qtyForPrice = maxremQty;

          unit_price = materialDataToUse?.unit_cost;
        }else{
          // maxremQty = Number(materialDataToUse?.unit_qty ?? materialDataToUse?.quantity ?? 0)
          maxremQty = qty * materialDataToUse?.convertion_qty;
          maxQty = qty * materialDataToUse?.convertion_qty -1;
          qtyForPrice = materialDataToUse?.convertion_qty;
          unit_price = Number(materialDataToUse?.unit_cost )/ Number(materialDataToUse?.convertion_qty);
        }
        
        const initialMovingQty = maxQty > 0 ? maxQty : 1
        console.log('initialMovingQty',initialMovingQty)
        console.log('initialMovingQty',maxQty)
        console.log('initialMovingQty',maxremQty)
        console.log('initialMovingQty',qty)
        console.log('initialMovingQty',materialDataToUse)
        console.log('initialMovingQty',unit_price)
        console.log('initialMovingQty',Number(materialDataToUse?.unit_cost ))
        console.log('initialMovingQty',Number(materialDataToUse?.convertion_qty))
        console.log('initialMovingQty',materialDataToUse?.unit_cost)
        console.log('initialMovingQty',materialDataToUse?.convertion_qty)
        setMovingQty(initialMovingQty) 
        setPartialTargetProduct({...materialDataToUse,remainingQty:maxQty,qtyForPrice:qtyForPrice,ogRemainingQty:maxremQty,unit_price:unit_price})
        let unitType = UNITS.find(unit => unit.id === materialDataToUse?.unit_id)
        let partialUnitType = materialDataToUse?.partial_unit ? UNITS.find(unit => unit.id === (materialDataToUse?.partial_unit ?? materialDataToUse?.convertion_unit)) : (materialDataToUse?.convertion_unit ? (UNITS.find(unit => unit.id === (materialDataToUse?.convertion_unit))) : null)
        setUnitType(materialDataToUse?.partial_unit ?? materialDataToUse?.convertion_unit ?? null)
        setConvertionUnit(partialUnitType ?? unitType)
        setConvertionUnitName(partialUnitType?.name ?? unitType?.name)
        setConvertionQty(initialMovingQty)
        const baseUnitCost = Number(
          materialDataToUse?.unit_cost ??
            materialDataToUse?.material_unit_cost ??
            materialDataToUse?.unit_price ??
            materialDataToUse?.unitPrice ??
            0
        );

        const unitCost = initialMovingQty > 0 ? materialDataToUse?.partial==1 ? baseUnitCost : (baseUnitCost / qtyForPrice) : 0
        setConvertionUnitPrice(unitCost)
        setConvertionTotalPrice(unitCost * initialMovingQty);
        setAutoFill(true)
        setPartialErrors({})
        setPartialModalOpen(true)
        setAddPartialStock(false)
      } else {
        await submitJobCostAPI(materialDataToUse);
        setQty(1)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleClosePartialModal = () => {
    setOpenPartialConfirm(false)
    setPartialModalOpen(false)
    setPartialTargetProduct(null)
    setMovingQty(1)
    setConvertionUnit(null)
    setPartialSize('')
    setConvertionQty(0)
    setConvertionUnitPrice(0)
    setConvertionTotalPrice(0)
    setAutoFill(true)
    setQty(1)
    setPartialErrors({})
  }

  const handleSubmitPartialFromWarning = () => {
    const newErrors = {}
    const maxQty = Number(partialTargetProduct?.qty ?? partialTargetProduct?.quantity ?? 0)

    if (!movingQty || Number(movingQty) <= 0) newErrors.movingQty = 'Required'
    if (maxQty > 0 && Number(movingQty) > maxQty) newErrors.movingQty = `Max ${maxQty}`
    if (!convertionUnit) newErrors.convertionUnit = 'Required'
    if (!convertionQty || Number(convertionQty) <= 0) newErrors.convertionQty = 'Required'

    if (Object.keys(newErrors).length > 0) {
      setPartialErrors(newErrors)
      return
    }

    setPartialErrors({})
    setOpenPartialConfirm(true)
  }

  const handleMoveToPartialFromWarning = async () => {
    try {
      const editFinishedProductId =
        partialTargetProduct?.id ?? partialTargetProduct?.product_id ?? null

      if (!editFinishedProductId) {
        enqueueSnackbar('Failed to move to partial: missing product id', { variant: 'error' })
        setOpenPartialConfirm(false)
        return
      }

      setOpenPartialConfirm(false)
      setPartialModalOpen(false)

      const response = await axios.post(
        `${REST_API_END_POINT}product/move-finished-product-partial`,
        {
          userId: user.user_id,
          editFinishedProductId,
          movingQty,
          convertionUnit,
          partialSize,
          convertionQty,
          convertionUnitPrice,
          convertionTotalPrice,
          autoFill,
          fromScan: true
        }
      )

      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' })
        onDataChange()
        await submitJobCostAPI({...partialTargetProduct,movigPartialQty:movingQty,});
      } else {
        enqueueSnackbar(response.data.message || 'Failed to move to partial', { variant: 'error' })
      }
    } catch (error) {
      console.error('Error moving to partial:', error)
      enqueueSnackbar('Failed to move to partial', { variant: 'error' })
    } finally {
      setPartialTargetProduct(null)
      setMovingQty(1)
      setConvertionUnit(null)
      setPartialSize('')
      setConvertionQty(0)
      setConvertionUnitPrice(0)
      setConvertionTotalPrice(0)
      setAutoFill(true)
      setPartialErrors({})
      setQty(1)
    }
  }


  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id)
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id]
      setTaskId(updatedState.length === 1 ? id : null)
      return updatedState
    })
  }

  const handleSelectAll = () => {
    if (isSelectAll) {
      setIsSelectAll(false)
      setCheckedItems([])
    } else {
      const allIds = data?.map((post) => String(post.ID)) || []
      setCheckedItems(allIds)
    }
    setIsSelectAll(!isSelectAll)
  }

  useEffect(() => {
    fetchTimeLogData()
  }, [isLoggedIn])

  useEffect(() => {
    if (isLoggedIn) {
      const intervalId = setInterval(() => {
        setOpenPopup(true)
      }, popUpTime * 60 * 1000)

      return () => {
        clearInterval(intervalId)
      }
    }
  }, [isLoggedIn])

  const updateClockInInput = (staffId, data) => {
    setClockInInputs((prev) => {
      const exists = prev.find((item) => item.staff_id === staffId);
      if (exists) {
        return prev.map((item) =>
          item.staff_id === staffId ? { ...item, ...data } : item
        );
      } else {
        return [...prev, { staff_id: staffId, ...data }];
      }
    });
  };
  
  const getClockInPayload = () => {
    const now = moment().unix();
    return clockInInputs
      .filter((entry) => {
        const hasHour = entry.hour > 0;
        // const hasService = entry?.service_id && entry?.service_id !== '';
        return hasHour ;
      })
      .map((entry) => ({
        ...entry,
        subtask_id: subTaskId,
        start_time: now - Math.round(entry.hour * 3600),
        end_time: now,
      }));
  };

  // const handleClockInOut = async () => {
  //   setLoading2(true)
  //   try {
  //     if (checkedItems?.length > 0) {
  //       let res = ''
  //       const now = Math.round(moment().valueOf() / 1000)
  //       if (isLoggedIn) {
  //         const timeLogId = staffTimeLog?.id
  //         const startTime = staffTimeLog?.start_time
  //         const staffId = staffTimeLog?.staff_id
  //         const staffHourlyRate = staffTimeLog?.staff_hourly_rate || 20
  //         res = await axios.post(
  //           `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
  //           {
  //             checkedItems,
  //             projectId,
  //             userId,
  //             timeLogId,
  //             taskId,
  //             startTime,
  //             now,
  //             staffId,
  //             staffHourlyRate,
  //             noSubTask:true,
  //             selectedService
  //           },
  //         )
  //         setFetchData(true)
  //       } else {
  //         res = await axios.post(
  //           `${REST_API_END_POINT}project-task/add-staff-task-timelog`,
  //           { checkedItems, projectId, userId, taskId, now, noSubTask:true ,selectedService},
  //         )
  //         // setFetchData(true)
  //       }
  //       setIsLoggedIn(!isLoggedIn)
  //       setOpenPopup(false)
  //       setElapsedTime(0)
  //       if (res.data.status === 1) {
  //         if (res.data.result === 'add') {
  //           enqueueSnackbar('Clocked In successfully', { variant: 'success' })
  //           setLoading2(false)
  //           setOpenService(false)
  //         } else if (res.data.result === 'update') {
  //           enqueueSnackbar('Clocked Out successfully', { variant: 'success' })
  //           setLoading2(false)
  //           setOpenService(false)
  //         }
  //       } else {
  //         console.log('handleClockInOut res : ', res.data)
  //       }
  //     } else {
  //       enqueueSnackbar('Please select a task', { variant: 'error' })
  //     }
  //   } catch (error) {
  //     console.log('HandleClockInOut error : ', error)
  //     setLoading2(false)
  //     setOpenService(false)
  //   }
  // }

  const handleClockInOut = async() => {
    const now = moment().unix();
    const memberClockins = getClockInPayload();
  
    if (memberClockins.length === 0) {
      enqueueSnackbar("Please enter time and select service for at least one member", { variant: 'error' });
      return;
    }
  
    const payload = {
      projectId,
      taskId,
      userId,
      isDriver: false,
      memberClockins,
      checkedItems: [String(subTaskId)],
      now,
      project_category: details?.project_category
    };
  
    console.log('🧾 Final Payload (not submitted):', payload);
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project-task/update-staff-task-timelog`,
        payload
      );
      console.log('✅ API Response:', res.data);
      if (res.data.status === 1) {
        enqueueSnackbar('Time log added successfully ', { variant: 'success' });
      setClockInInputs([]);      
      setElapsedTime(0);    
      setIsLoggedIn(false);  
      setFetchData(true); 
      handleClose(); 
    } else {
      console.log('⚠️ failed to add Time log', res.data);
      enqueueSnackbar("Clock-in failed", { variant: 'error' });
      handleClose(); 
    }
    } catch (error) {
      console.error('❌ API Error:', error);
      enqueueSnackbar("Clock-in failed", { variant: 'error' });
      handleClose(); 
    }
  };

  const handleClose = () => {
    setOpenService(false)
    setClockInInputs([])
    setSubTaskMembers([])
  }
  const handleClosePopup = (continueWorking) => {
    setOpenPopup(false)
    if (!continueWorking) {
      handleClockInOut()
    }
  }

  useEffect(() => {
    if (staffTimeLog) {
      const interval = setInterval(() => {
        const now = Math.round(moment().valueOf() / 1000)
        const difference = now - staffTimeLog?.start_time

        setElapsedTime(difference)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [staffTimeLog])

  const hours = String(Math.floor(elapsedTime / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((elapsedTime % 3600) / 60)).padStart(2, '0')
  const seconds = String(elapsedTime % 60).padStart(2, '0')

  const handleAddMaterialToJobCost = async (materialBarcode,initialTry = 1) => {
    try {
      if (materialBarcode && materialBarcode != '') {
        if (materialBarcode.startsWith('C')) {
          if(details?.project_category == 12){
          return enqueueSnackbar("Can't add a catalog item to a T&M job.", { variant: 'error' });
          }
          const response = await axios.post(
            `${REST_API_END_POINT}project/update-product-in-jobcost`,
            { userId: user.user_id, materialBarcode, projectId, taskId, qty },
          )
          // if (response.data.status === 1) {
          //   enqueueSnackbar(response.data.message, { variant: 'success' })
          //   setQty(1)
          //   setSearchMaterial('')
          // } else if (response.data.message) {
          //   enqueueSnackbar(response.data.message, { variant: 'error' })
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' })
            setQty(1)
            setSearchMaterial('')
          } else if (response.data.status === 2 || response.data.status === 3 || response.data.status === 4) {
            setConfirmAdditionalJObCost(true)
            // setWarningMaterialPopup(true)
            setConfirmMessage(response.data.message)
            setMaterialData(response.data.materialData)
          } else if (response.data.status === 5) {
            setWarningMaterialPopup(true)
            setWarningMaterialData(response.data.materialData)
          }
          else if (response.data.status === 8) {
          enqueueSnackbar(response.data.message, { variant: 'error' })
        }
         else if (response.data.message) {
            enqueueSnackbar(response.data.message, { variant: 'error' })
          } else {
            enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
          }
        }else {
          const response = await axios.post(
          `${REST_API_END_POINT}project/update-material-in-jobcost`,
          { userId: user.user_id, materialBarcode, projectId, taskId ,qty,initialTry:initialTry,selectedInstallation:selectedInstallation},
        )
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' })
          // setQty(1)
          setSearchMaterial('')
        } else if (response.data.status === 2 || response.data.status === 3 || response.data.status === 4 || response.data.status === 6) {
          // setConfirmAdditionalJObCost(true)
          setConfirmMessage(response.data.message)
          setMaterialData(response.data.materialData)

          setWarningMaterialPopup(true);
          setWarningMaterialData(response.data.materialData);

          let remainingQty = 0;
          let matData = response.data.materialData;
          if (matData?.partial == 1) {
            // remainingQty = remainingQty = matData?.qty - qty;
            remainingQty = qty>1 ? qty:0;
          } else {
            // remainingQty = remainingQty = matData?.unit_qty - qty;
            remainingQty =  matData?.unit_qty - qty;
          }
          
          if(remainingQty > 0 || (matData?.partial == 0 && remainingQty >= 0)){
            setPartialCondition(true)
          }else{
            setPartialCondition(false)  
          }
        } else if (response.data.status === 5) {
          if(response.data.materialData?.qty < qty){
            // setWarningMaterialPopup(true)
            // setWarningMaterialData(response.data.materialData)
            // setAddPartialStock(true)
            enqueueSnackbar("Quantity is greater than the available quantity", { variant: 'error' })
          }else{
            let remainingQty = 0;
            let matData = response.data.materialData;
            if (matData?.partial == 1) {
              remainingQty = matData?.qty - qty;
              // remainingQty = qty>1 ? qty:0;
            } else {
              // remainingQty = remainingQty = matData?.unit_qty - qty;
              // remainingQty = matData?.unit_qty - qty;
              remainingQty = matData?.qty - qty;
            }
            
            if(remainingQty > 0 || (matData?.partial == 0 && remainingQty >= 0)){
              setPartialCondition(true)
            }else{
              setPartialCondition(false)  
            }
            setWarningMaterialPopup(true)
            setWarningMaterialData(response.data.materialData)
          }
        }else if(response.data.status === 6){
          setConfirmAdditionalJObCost(true)
          setConfirmMessage(response.data.message)
          setMaterialData(response.data.materialData)
          setRetryFirstApiCall(true)
        } else if (response.data.message) {
          enqueueSnackbar(response.data.message, { variant: 'error' })
        } else {
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' })
        }
        // setQty(1)
        let jobCostResult = response?.data?.jobCostResult?.[0] || null;
        setExistingJobCostData(jobCostResult || null)
        setFutureInstallations(response?.data?.futureInstallation || [])
        setSelectedInstallation(response?.data?.futureInstallation?.find(item => item?.location_id === jobCostResult?.for_product || item?.location_id === jobCostResult?.for_service) || null)
        }
      }
    } catch (error) {
      console.log('Error in add material to jobcost', error)
    }
  }

  const handleViewAddedMaterials = async () => {
    setLoadingMaterials(true)
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}project/view-added-material-in-task`,
        { projectId, taskId },
      )
      if (response.data.status === 1) {
        setViewMaterialData(response.data.result)
      } else {
        enqueueSnackbar('Failed to view materials', { variant: 'error' })
        setViewMaterialData([])
      }
    } catch (error) {
      console.log('Error in add material to jobcost', error)
      setViewMaterialData([])
    } finally {
      setLoadingMaterials(false)
    }
  }

  const getProjectTaskCardJsx = (post, inBundleModal) => {
    const hasLinkedStack =
      !inBundleModal && Array.isArray(post?.linked_tasks) && post.linked_tasks.length > 0
    const cardTaskName = hasLinkedStack && post?.parent_product_name ? post.parent_product_name : post.name
    const cardTaskProductName = hasLinkedStack && post?.customer_order_product_name ? post.customer_order_product_name : post.productName
    const groupedTasks = hasLinkedStack ? [post, ...(post?.linked_tasks || [])] : [post]
    const toNum = (v) => {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    }
    const parseHMS = (val) => {
      if (!val) return 0
      const parts = String(val).split(':').map((p) => Number(p))
      if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return 0
      return parts[0] * 3600 + parts[1] * 60 + parts[2]
    }
    const fmtHMS = (secs) => {
      const total = Math.max(0, Math.floor(secs))
      const h = String(Math.floor(total / 3600)).padStart(2, '0')
      const m = String(Math.floor((total % 3600) / 60)).padStart(2, '0')
      const s = String(total % 60).padStart(2, '0')
      return `${h}:${m}:${s}`
    }
    const aggregate = groupedTasks.reduce(
      (acc, t) => {
        const qtyVal =
          toNum(t?.is_single_card) === 1 && toNum(t?.location_quantity) > 0
            ? toNum(t?.location_quantity)
            : toNum(t?.location_quantity) > 0
              ? 1
              : toNum(t?.service_qty)
        acc.complete += toNum(t?.complete)
        acc.file_count += toNum(t?.file_count)
        acc.post_count += toNum(t?.post_count)
        acc.subtask_count += toNum(t?.subtask_count)
        acc.subtask_completed_count += toNum(t?.subtask_completed_count)
        if (Array.isArray(t?.subTasks)) {
          acc.subTasks.push(...t.subTasks)
        }
        acc.qty += qtyVal
        acc.totalSeconds += parseHMS(t?.total_hours)
        return acc
      },
      {
        complete: 0,
        file_count: 0,
        post_count: 0,
        subtask_count: 0,
        subtask_completed_count: 0,
        subTasks: [],
        qty: 0,
        totalSeconds: 0,
      },
    )
    const aggregatedComplete = groupedTasks.length
      ? Math.round(aggregate.complete / groupedTasks.length)
      : toNum(post?.complete)
    const aggregatedQty = aggregate.qty
    const aggregatedTotalHours = fmtHMS(aggregate.totalSeconds)
    let cardStatus = post?.status
    let completedGroupedTasksCount = 0
    if (hasLinkedStack) {
      const statuses = groupedTasks.map((t) => toNum(t?.status))
      completedGroupedTasksCount = statuses.filter((s) => s === 3 || s === 4 || s === 5).length
      if (statuses.every((s) => s === 3 || s === 4 || s === 5)) {
        cardStatus = 3
      } else if (statuses.some((s) => s === 2 || s === 3 || s === 4 || s === 5)) {
        cardStatus = 2
      } else {
        cardStatus = 1
      }
    }
    return (
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    ...(inBundleModal
                      ? { maxWidth: '100%', mx: 0 }
                      : { maxWidth: 480, mx: 'auto' }),
                    ...(hasLinkedStack
                      ? {
                          pt: 1.5,
                          pr: 1.5,
                          pl: 1,
                          pb: 0.5,
                          transition: 'transform 0.22s ease',
                          '&:hover': { transform: 'scale(1.02)' },
                        }
                      : {}),
                  }}
                >
                  {hasLinkedStack && (
                    <>
                      <Box
                        aria-hidden
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: 4,
                          right: 14,
                          bottom: 6,
                          borderRadius: 2,
                          bgcolor: 'background.paper',
                          border: (t) => `1px solid ${t.palette.divider}`,
                          boxShadow: (t) => t.shadows[3],
                          transform: 'rotate(-4deg)',
                          zIndex: 0,
                          pointerEvents: 'none',
                        }}
                      />
                      <Box
                        aria-hidden
                        sx={{
                          position: 'absolute',
                          top: 4,
                          left: 8,
                          right: 10,
                          bottom: 4,
                          borderRadius: 2,
                          bgcolor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[100] : t.palette.grey[900],
                          border: (t) => `1px solid ${t.palette.divider}`,
                          boxShadow: (t) => t.shadows[2],
                          transform: 'rotate(3deg)',
                          zIndex: 0,
                          pointerEvents: 'none',
                        }}
                      />
                      <Box
                        aria-hidden
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 6,
                          right: 8,
                          bottom: 2,
                          borderRadius: 2,
                          bgcolor: 'background.paper',
                          border: (t) => `1px solid ${t.palette.divider}`,
                          boxShadow: (t) => t.shadows[1],
                          transform: 'rotate(-2deg)',
                          zIndex: 0,
                          pointerEvents: 'none',
                        }}
                      />
                    </>
                  )}
                <Card
                    title={hasLinkedStack ? 'Click to open bundle tasks' : undefined}
                  onClickCapture={(e) => {
                    if (inBundleModal) {
                      const interactive = e.target.closest(
                        'button, a, [role="checkbox"], .MuiIconButton-root, .MuiCheckbox-root, .MuiButtonBase-root, .MuiSvgIcon-root, input, textarea, iframe',
                      )
                      if (interactive) return
                      e.preventDefault()
                      e.stopPropagation()
                      setBundleStackModalPost(null)
                      openViewTaskForPost(post)
                      return
                    }
                    if (!hasLinkedStack) return
                    const interactive = e.target.closest(
                      'button, a, [role="checkbox"], .MuiIconButton-root, .MuiCheckbox-root, .MuiButtonBase-root, .MuiSvgIcon-root, input, textarea, iframe',
                    )
                    if (interactive) return
                    e.preventDefault()
                    e.stopPropagation()
                    setBundleStackModalPost(post)
                  }}
                  onMouseEnter={() => setIsHover(true)}
                  onMouseLeave={() => setIsHover(false)}
                  sx={{
                    position: 'relative',
                    zIndex: hasLinkedStack ? 1 : undefined,
                    minWidth: { xs: 0, sm: 220 },
                    width: '100%',
                    transition: hasLinkedStack ? undefined : 'transform 0.2s',
                    ...(hasLinkedStack
                      ? {}
                      : {
                          '&:hover': {
                            transform: 'scale(1.02)',
                          },
                        }),
                    ...(isSalesOrderVoided
                      ? {
                          position: 'relative',
                          backgroundColor:
                            theme.palette.mode === 'light'
                              ? alpha(theme.palette.grey[500], 0.14)
                              : alpha(theme.palette.grey[600], 0.28),
                          filter: 'grayscale(75%)',
                          opacity: 0.85,
                        }
                      : {}),
                    border: post?.facility_id ? 
                      `1px solid ${FacilityTypes.find(facility => facility.id === post.facility_id)?.color ? 
                        theme.palette[FacilityTypes.find(facility => facility.id === post.facility_id).color].main : 
                        theme.palette.grey[500]}` : '1px solidrgb(119, 119, 119)',
            boxShadow: post?.facility_id ?
              `0 -2px 8px ${FacilityTypes.find(facility => facility.id === post.facility_id)?.color ? 
                theme.palette[FacilityTypes.find(facility => facility.id === post.facility_id).color].main : 
                theme.palette.grey[500]}40, 0 4px 12px ${FacilityTypes.find(facility => facility.id === post.facility_id)?.color ? 
                theme.palette[FacilityTypes.find(facility => facility.id === post.facility_id).color].main : 
                theme.palette.grey[500]}30, 0 2px 6px ${FacilityTypes.find(facility => facility.id === post.facility_id)?.color ? 
                theme.palette[FacilityTypes.find(facility => facility.id === post.facility_id).color].main : 
                theme.palette.grey[500]}20` : '0 -2px 8px rgb(119, 119, 119)40, 0 4px 12px rgb(119, 119, 119)30, 0 2px 6px rgb(119, 119, 119)20',
                  }}
                >
                  {hasLinkedStack && completedGroupedTasksCount>0&&(
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 12,
                        left: 12,
                        zIndex: 25,
                      }}
                    >
                      <Label
                        // color={completedGroupedTasksCount === groupedTasks.length ? 'success' : 'info'}
                        color={'success'}
                        variant="filled"
                        sx={{
                          boxShadow: (theme) => theme.shadows[4],
                          fontWeight: 'bold',
                          fontSize: '0.75rem',
                        }}
                      >
                        {completedGroupedTasksCount}/{groupedTasks.length} Completed
                      </Label>
                    </Box>
                  )}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      zIndex: 20,
                      padding: '12px',
                    }}
                  >

                    {isHover &&
                      !taskId &&
                      user.user_type !== 3 &&
                      currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                      currentTab != 'Completed' &&
                      currentTab != 'Hold' &&
                      details?.status != 3 &&
                      canModifyTasks &&
                      details?.status != 9 &&
                      post.from_product === 0 && (
                        <DeleteOutlineOutlined
                          onClick={() => handleDeleteClick(post.ID)}
                          sx={{
                            zIndex: 10,
                            top: 17,
                            right: 16,
                            color: theme.palette.grey[500],
                            position: 'absolute',
                            cursor: user.user_type == 3 ? 'default' : 'pointer',
                          }}
                        />
                      )}
                    {!taskId &&
                      user.user_type !== 3 &&
                      currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                      currentTab != 'Completed' &&
                      currentTab != 'Hold' &&
                      details?.status !== 1 &&
                      details?.status != 3 &&
                      canModifyTasks &&
                      details?.status != 9 &&
                      post?.status != 3 &&
                      // (post?.isAdditionalProduct === 1 || post?.service_isAdditionalProduct == 1) &&
                      (isTimeAndMaterial && ((post?.is_manually_added === 1 && post?.subtask_count > 0) || 
                       (post?.is_manually_added === 0 && post?.subtask_count === 0 && post?.service_workflow === null) ||
                       (post?.subtask_count > 0 && post?.service_workflow === null)) || (post?.status == 2 && post?.subtask_count == post?.subtask_completed_count)) && (
                        <Button
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={()=>{
                            // Check if this is the condition that needs confirmation (manually added = 0, subtask_count = 0, service_workflow = null)
                            if (post?.is_manually_added === 0 && post?.subtask_count === 0 && post?.service_workflow === null) {
                              setSelectedTaskForCompletion(post);
                              setOpenServiceWorkflowConfirmation(true);
                            } else {
                              // Normal complete for other conditions (including subtask_count > 0 and service_workflow = null)
                              handleUpdateStatus(3, post.ID, post.project_id);
                            }
                          }}
                          sx={{
                            position: 'absolute',
                            top: 15,
                            right: 200,
                            zIndex: 10
                          }}
                        >
                          Push to Complete
                        </Button>
                      )}
                    {/* <Box sx={{ px: 2, py: 1, textAlign: 'center', justifyContent: 'center' }}> */}
                    {
                      user.user_type !== 3 &&
                        // currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                        // details?.status != 3 &&
                        currentTab != 'Completed' &&
                        currentTab != 'Hold' &&
                        details?.job_category_name == 'Time & Material' &&
                        canModifyTasks && projectData?.status !==1 &&(
                          // <Stack
                          //   direction={'row'}
                          //   justifyContent={'space-between'}
                          //   alignItems={'center'}
                          // >
                          <Checkbox
                            sx={{
                              cursor:
                                user.user_type === 3 ? 'default' : 'pointer',
                              display: 'none',
                                // !taskId || post?.ID == taskId
                                //   ? 'block'
                                //   : 'none',
                              zIndex: 10,
                              position: 'absolute',
                              top: 10,
                              right: 45,
                              color: theme.palette.grey[500],
                            }}
                            // disabled={taskId ? (post?.ID == taskId ? false : true) : false}
                            checked={
                              checkedItems?.includes(String(post?.ID))
                                ? true
                                : false
                            }
                            onChange={() => {
                              isLoggedIn 
                                ? null
                                : handleCheckboxChange(String(post.ID))
                            }}
                            color="primary"
                          />
                        )
                      // </Stack>
                    }
                    {post.service_id != null && (
                      <Tooltip title={sentenceCase(post.name ==="Labor Install" ? "Service" : post.rfp == 1 ? 'Proposal service' : 'Additional Service')}>
                      <Typography sx={{
                        zIndex: 10,
                        position: 'absolute',
                        top: '140px',
                        right: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 150,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}>
                        <Label
                          color={post?.rfp == 1 ? 'info' : 'secondary'}
                          variant={ theme.palette.mode === 'light' ? 'ghost' : 'filled' }
                        >
                          {sentenceCase(post.name ==="Labor Install" ? "Service" : post.rfp == 1 ? 'Proposal service' : 'Additional Service')}
                        </Label>
                      </Typography>
                      </Tooltip>
                    )}
                    {/* </Box> */}
                  </Box>
                  <CardMediaStyle
                    onClick={() => {
                      if (blockTaskAccessIfVoided()) return
                      if(popupOn){
                        (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material') )
                        ? null:
                        handleOpenTask(post.ID,post.project_id,currentTab,details)
                      }else{
                          ((user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                          ? null
                          : navigate(
                              PATH_DASHBOARD.project.viewTask +
                                post.ID +
                                '/' +
                                post.project_id,
                              { state: { currentTab: currentTab,details:details } },
                            ))}
                    }}
                  >
                    {(() => {
                      const imageUrl = post?.product_design && post?.approved == 1
                        ? post?.product_design 
                        : post?.avatarUrl 
                        ? post?.avatarUrl
                        : logo;
                                            const mediaType = post?.file_type || post?.mime_type || '';
                      const mediaExtension = post?.extension || '';
                      const isPdf = isPdfUrl(imageUrl, mediaType, mediaExtension);
                      const isGoogleViewerDesign = isGoogleViewerDesignUrl(imageUrl, mediaType, mediaExtension);
                      
                      if (isPdf) {
                        return (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: 'rgba(0, 0, 0, 0.05)',
                            }}
                          >
                            <Tooltip title="View PDF">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPdfLoading(true);
                                  setSelectedPDF(imageUrl);
                                  setOpenPDFModal(true);
                                  setUseOfficeViewer(true);
                                }}
                                aria-label="open pdf"
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 200,
                                  color: theme.palette.error.main,
                                  backgroundColor: theme.palette.text.primary,
                                }}
                              >
                                <PictureAsPdf style={{ fontSize: 50 }} />
                              </IconButton>
                            </Tooltip>
                            <iframe
                              src={imageUrl}
                              title={imageUrl}
                              style={{
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                              }}
                              frameBorder="0"
                            />
                          </Box>
                        );
                      }
                      if (isGoogleViewerDesign) {
                        return (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              zIndex: 8,
                            }}
                          >
                            <iframe
                              src={`https://docs.google.com/gview?url=${encodeURIComponent(imageUrl)}&embedded=true`}
                              title={imageUrl}
                              width="100%"
                              height="100%"
                              frameBorder="0"
                              style={{ border: 'none' }}
                            />
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: 'calc(100% - 72px)',
                                zIndex: 9,
                                cursor: user.user_type == 3 ? 'default' : 'pointer',
                              }}
                            />
                          </Box>
                        );
                      }
                      return (
                        <CoverImgStyle src={imageUrl} />
                      );
                    })()}
                  </CardMediaStyle>
                  <Box
                    sx={{
                      p: 1.5,
                      textAlign: 'center',
                      justifyContent: 'center',
                      cursor: user.user_type == 3 ? 'default' : 'pointer',
                    }}
                    // onClick={() => {
                    //   (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                    //     ? null
                    //     : navigate(
                    //         PATH_DASHBOARD.project.viewTask +
                    //           post.ID +
                    //           '/' +
                    //           post.project_id,
                    //         {
                    //           state: {
                    //             designs: designs,
                    //             currentTab: currentTab,
                    //             details:details
                    //           },
                    //         },
                    //       )
                    // }}
                    onClick={() => {
                      if (blockTaskAccessIfVoided()) return
                      if(popupOn){
                        (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                        ? null:
                        handleOpenTask(post.ID,post.project_id,currentTab,details)
                      }else{
                          ((user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                          ? null
                          : navigate(
                              PATH_DASHBOARD.project.viewTask +
                                post.ID +
                                '/' +
                                post.project_id,
                              { state: { currentTab: currentTab,details:details } },
                            ))}
                    }}
                  >
                    <Stack
                      direction={'row'}
                      justifyContent={'space-between'}
                      alignItems={'center'}
                    >
                      <Typography
                        sx={{
                          cursor: user.user_type == 3 ? 'default' : 'pointer',
                        }}
                        // onClick={() => {
                        //   (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                        //     ? null
                        //     : navigate(
                        //         PATH_DASHBOARD.project.viewTask +
                        //           post.ID +
                        //           '/' +
                        //           post.project_id,
                        //         {
                        //           state: {
                        //             designs: designs,
                        //             currentTab: currentTab,
                        //             details:details
                        //           },
                        //         },
                        //       )
                        // }}
                        onClick={() => {
                          if (blockTaskAccessIfVoided()) return
                          if(popupOn){
                            (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                            ? null:
                            handleOpenTask(post.ID,post.project_id,currentTab,details)
                          }else{
                              ((user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                              ? null
                              : navigate(
                                  PATH_DASHBOARD.project.viewTask +
                                    post.ID +
                                    '/' +
                                    post.project_id,
                                  { state: { currentTab: currentTab,details:details } },
                                ))}
                        }}
                        variant="subtitle2"
                        align="center"
                      >
                        {/* ts name */}
                          <Typography variant='subtitle2' sx={{ fontWeight: 'bold', mb: 1, textAlign: 'left' ,wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line', }}>
                         {cardTaskName} {cardTaskName == "Labor Install" ? `(${post?.productName}) ` : ''}
                          </Typography>

                          {post.product_id && post.product_notes && post.product_notes !== '' || post.service_notes && post?.service_notes && post.service_notes!=='' ?

                            // <Typography variant='subtitle2' sx={{ fontWeight: 'bold' , mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-line', color: 'error.main' }}>Note:  {" "} {post.product_notes}</Typography>
                            <Tooltip title={<span style={{ whiteSpace: 'pre-line', color: "#ff0000", fontWeight: "bold" }}>
                              <span style={{ fontWeight: "bolder" }}>Note : {" "}</span>{post.product_notes}{post?.service_notes}
                            </span>}>
                              <Typography variant='subtitle2' sx={{ textAlign: 'left' ,fontWeight: 'bold', mb: 1, color: 'error.main' }}>Note :  {"  "}{post?.product_notes?.length > 20
                                ? post.product_notes.slice(0, 20) + '...'
                                : post?.product_notes}  {post?.service_notes?.length > 20
                                ? post.service_notes.slice(0, 20) + '...'
                                : post?.service_notes}
                              </Typography>
                            </Tooltip>
                            : ""}
                        </Typography>

                      {/* <Typography
                    variant="overline"
                    sx={{ mt: 3, display: 'block', color: 'text.secondary' }}
                  >
                    Completion :{post.complete}%
                  </Typography> */}
                      {/* { console.log("#############Post",post)}
                    {post && <Sliderw
                      aria-label="Percentage"
                      defaultValue={post.complete}
                      
                      getAriaValueText={() => post.complete}
                      // onChange={(event, value) => updateStatus(event, post.ID)}
                      valueLabelDisplay={true}
                    onMouseEnter={post.complete}
                      //  step={10}
                      marks
                      min={10}
                      max={100}
                      disabled={true}
                    />} */}
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        {post.product_id != null && post.status === 3 && (
                          <FinishedProductmenu
                            url={`${BASE_URL}view-finished-task/${post.ID}/`}
                            id={projectId}
                            useIcon={true}
                          />
                        )}
                        {isSalesOrderVoided ? (
                          <Typography>
                            <Label
                              color="error"
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                            >
                              {sentenceCase('Void')}
                            </Label>
                          </Typography>
                        ) : details?.hold == 1 ? (
                          <Typography>
                            <Label
                              color={'warning'}
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                            >
                              {sentenceCase('Hold')}
                            </Label>
                          </Typography>
                        ) :details?.status == 9 ? (
                          <Typography>
                            <Label
                              color={'error'}
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                            >
                              {sentenceCase('Rejected')}
                            </Label>
                          </Typography>
                        ) : (
                          <Typography>
                            <Label
                              variant={
                                theme.palette.mode === 'light'
                                  ? 'ghost'
                                  : 'filled'
                              }
                              color={
                                option.find((opt) => opt?.id === cardStatus)?.color || ''
                              }
                            >
                              {sentenceCase(
                                option.find((opt) => opt?.id === cardStatus)?.value || '',
                              )}
                            </Label>
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                    <SubTaskMeterChart
                      subTasks={aggregate.subTasks}
                      subtaskCount={aggregate.subtask_count}
                      completedCount={aggregate.subtask_completed_count}
                      theme={theme}
                    />
                    {(post.from_product === 0 ) ? (
                      ''
                    ) : (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent= {post?.facility_id ? "center" : "space-between"}
                        marginTop={1.5}
                      >
                        {/* Left side: LocationOn icon and location name */}
                        {/* {post?.product_map_service == 1 ?
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <LocationOn sx={{ color: theme.palette.error.main }} />
                            <Tooltip
                              title={
                                <Box>
                                  {post?.locations?.map((location, index) => (
                                    <Typography key={index} variant="caption" sx={{ display: 'block' }}>
                                      {`${index + 1}) ${location.address}, ${location.city}, ${location.state}, ${location.zip}`}
                                    </Typography>
                                  ))}
                                </Box>
                              }
                              arrow
                              placement="top"
                            >
                              <Typography
                                sx={{ color: theme.palette.primary.main }}
                                variant="subtitle2"
                                align="center"
                              >
                                {post?.locations?.length} Locations
                              </Typography>
                            </Tooltip>
                          </Stack>
                        : */}
                          <Stack direction="row" alignItems="center" spacing={1}>
                            {(post.name !=="Labor Install" && !post?.facility_id ) ?
                            <LocationOn
                            sx={{ color: theme.palette.error.main }}
                            />
                            : ''
                          }
                            <Typography
                              sx={{ color: theme.palette.primary.main }}
                              variant="subtitle2"
                              align="center"
                            >
                              {post.service_id != null ? post.service_location : post.location}
                            </Typography>
                          </Stack>
                        {/* } */}
                         {post?.facility_id ? (
                           <Typography>
                              <Label
                                 variant="outlined"
                                 sx={{ 
                                   fontSize: '0.75rem', 
                                   fontWeight: 'bold',
                                   borderWidth: '2px',
                                   backgroundColor: 'transparent',
                                   borderColor: theme.palette.warning.main,
                                   color: theme.palette.warning.main,
                                   boxShadow: `0 -1px 4px rgba(255, 193, 7, 0.4), 0 2px 6px rgba(255, 193, 7, 0.3), 0 1px 3px rgba(255, 193, 7, 0.2)`,
                                   '&:hover': {
                                     opacity: 0.8
                                   }
                                 }}
                               >
                                 📍 {FacilityTypes.find(f => f.id === post.facility_id)?.label || `Facility ${post.facility_id}`}
                               </Label>
                           </Typography>
                         ):
                        <>
                        {/* Right side: Quantity */}
                        <Typography
                        sx={{ cursor: 'pointer' }}
                        variant="subtitle2"
                        align="center"
                        >
                          {/* Quantity: {post.location_quantity ? 1 : post.service_qty} */}
                          Quantity: {aggregatedQty}
                          
                        </Typography>
                          </>
                          }
                      </Stack>
                    )}
                    <Stack>
                      <Typography
                        variant="overline"
                        sx={{
                          mt: 2,
                          display: 'block',
                          // color: 'text.secondary',
                        }}
                      >
                        Completion :{aggregatedComplete}%
                      </Typography>
                      {post.product_id != null && post.status === 3 && (
                        <Box
                          component="span"
                          sx={{ display: 'inline-flex', lineHeight: 0 }}
                          onClick={(e) => e.stopPropagation()}
                          onMouseDown={(e) => e.stopPropagation()}
                        >
                          <FinishedProductmenu
                            url={`${BASE_URL}view-finished-task/${post.ID}/`}
                            id={projectId}
                            useIcon={true}
                          />
                        </Box>
                      )}
                    </Stack>
                  </Box>
                  <Box
                    sx={{
                      p: 1.5,
                      textAlign: 'center',
                      justifyContent: 'center',
                      cursor: user.user_type == 3 ? 'default' : 'pointer',
                    }}
                    // onClick={() => {
                    //   (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                    //     ? null
                    //     : navigate(
                    //         PATH_DASHBOARD.project.viewTask +
                    //           post.ID +
                    //           '/' +
                    //           post.project_id,
                    //         {
                    //           state: {
                    //             designs: designs,
                    //             currentTab: currentTab,
                    //             details:details
                    //           },
                    //         },
                    //       )
                    // }}
                    onClick={() => {
                      if (blockTaskAccessIfVoided()) return
                      if(popupOn){
                        (user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                        ? null:
                        handleOpenTask(post.ID,post.project_id,currentTab,details)
                      }else{
                          ((user.user_type == 3 || (taskId && details?.job_category_name == 'Time & Material'))
                          ? null
                          : navigate(
                              PATH_DASHBOARD.project.viewTask +
                                post.ID +
                                '/' +
                                post.project_id,
                              { state: { currentTab: currentTab,details:details,designs:designs } },
                            ))}
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={1.5}
                    >
                      <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        flexWrap="wrap"
                        useFlexGap
                        sx={{ flex: 1, minWidth: 0 }}
                      >
                      {/* <Stack spacing={1} alignItems={'center'} direction={'row'}>
                    <Groups sx={{ width: 17 }} />
                    <Typography variant="subtitle2">{post.member_count}</Typography>
                  </Stack> */}
                      <Stack
                        spacing={1}
                        alignItems={'center'}
                        direction={'row'}
                      >
                        <Attachment sx={{ width: 22 }} />
                        <Typography variant="subtitle2">
                          {aggregate.file_count}
                        </Typography>
                      </Stack>
                      <Stack
                        spacing={1}
                        alignItems={'center'}
                        direction={'row'}
                      >
                        <ChatBubble sx={{ width: 22 }} />
                        <Typography variant="subtitle2">
                          {aggregate.post_count}
                        </Typography>
                      </Stack>
                      <Stack
                        spacing={1}
                        alignItems={'center'}
                        direction={'row'}
                      >
                        <CheckBoxRounded sx={{ width: 22 }} />
                        <Typography variant="subtitle2">
                          {aggregate.subtask_count}
                        </Typography>
                      </Stack>
                      <Stack
                        spacing={1}
                        alignItems={'center'}
                        direction={'row'}
                      >
                        <AccessTime sx={{ width: 22 }} />
                        <Typography variant="subtitle2">
                          {aggregatedTotalHours}
                        </Typography>
                      </Stack>
                    </Stack>
                    {!inBundleModal && post.status != 3 && details?.status == 2 && post.is_manually_added != 1 && details?.project_category !== 12 && SchedulePermission && ((post.service_id &&  post.makeInstallCard == 1) || post.product_id) &&
                      (post.is_scheduled == 1 && post.schedule_date != null ? (
                        <Stack
                          spacing={0.25}
                          sx={{ flexShrink: 0, alignSelf: 'center', alignItems: 'center' }}
                        >
                          <Typography
                            variant="caption"
                            color="primary"
                            sx={{ lineHeight: 1.2, display: 'block' }}
                          >
                            Scheduled date
                          </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                          <Typography variant="subtitle2" sx={{ lineHeight: 1.2, display: 'block' }}>
                            {moment.unix(Number(post.schedule_date)).format('MM/DD/YYYY')}
                          </Typography>
                          <IconButton
                              size="small"
                              color="primary"
                              onClick={(e) => handleOpenScheduleDialog(e, post)}
                              sx={{ p: 0.5 }}
                            >
                              <Icon icon={editFill} width={16} height={16} />
                            </IconButton>
                          </Stack>
                        </Stack>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          sx={{ flexShrink: 0 }}
                          onClick={(e) => handleOpenScheduleDialog(e, post)}
                        >
                          Schedule{" "}
                          {getDeliveryTypeText(
                            post?.service_delivery_type_id || 
                            post?.delivery_type_id || 1
                          )}
                        </Button>
                      ))}
                    </Stack>
                  </Box>
                </Card>
                </Box>
    )
  }

  return (
    <>
      {valueTab === 'one' ? (
        <>
          <Grid container spacing={3}>
            {details?.job_category_name == 'Time & Material' ? (
              <Box sx={{ width: '100%' }}>
                {user.user_type !== 3 &&
                  currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                  currentTab != 'Completed' &&
                  currentTab != 'Hold' &&
                  data?.status !== 3 &&
                  canModifyTasks && hasJobCostPermission && (
                    <Stack
                      justifyContent="space-between"
                      alignItems="center"
                      // flexDirection="row"
                      flexDirection={isSmallScreen ? 'column' : 'row'}
                     
                      sx={{ mb: 2, mt: 2, pl: 5 }}
                    >
                       <Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{mb:2}} >
                      <TextField
                        size='small'
                        type="number"
                        label={'Enter Qty'}
                        placeholder='Enter Qty'
                        value={qty || ''}
                        inputProps={{ min: 0.01, step: "any" }}
                        onChange={(e)=>{
                          setQty(e.target.value);
                        }}
                        onBlur={(e) => {
                          let val = Number(e.target.value);
                          if (e.target.value === '' || isNaN(val) || val <= 0) {
                            setQty(1);
                          } else {
                            setQty(val);
                          }
                        }}
                        onKeyDown={(event) => {
                          if (event.key === '-' || event.key === '+') {
                            event.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur()
                          e.preventDefault()
                        }}
                      />

                      <TextField
                        size='small'
                        fullWidth
                        label={'Scan Material'}
                        placeholder="Scan Material"
                        value={searchMaterial}
                        onChange={(e) => {
                          setSearchMaterial(e.target.value)
                          handleAddMaterialToJobCost(e.target.value)
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                      />
</Stack>
<Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{mb:2}} >
<>
      {/* Icon Button to trigger QR scanner */}
 {/* QR Code Scanner Icon */}
 <IconButton onClick={() => setOpenQRScanner(true)}>
        <QrCodeScanner sx={{ fontSize: "30px" }} />
      </IconButton>

      {/* Dialog for QR Scanner */}
      <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
        <DialogTitle>Scan QR Code</DialogTitle>
        <DialogContent>
          <div id="reader" style={{ width: "100%" }}></div>
        </DialogContent>
      </Dialog>
    </>
                      <Tooltip title='View Added Materials'>
                      <Button
                        variant="contained"
                        sx={{width:'200px'}}
                        type="submit"
                        onClick={() => {
                          handleViewAddedMaterials()
                          setViewMaterial(true)
                        }}
                        startIcon={
                          <Stack>
                            <Visibility />
                          </Stack>
                        }
                      >
                        View Materials
                      </Button>
                      </Tooltip>
                      </Stack>
                    </Stack>
                  )}
                {data?.length >= 0 && (
                  <Stack
                    justifyContent="space-between"
                    alignItems="center"
                    flexDirection="row"
                  >
                    <Stack
                      justifyContent="flex-start"
                      alignItems="center"
                      flexDirection="row"
                    >
                      <Typography variant="subtitle1">
                        {checkedItems?.length > 0 &&
                          checkedItems?.length + ' selected'}
                      </Typography>
                    </Stack>
                    {user.user_type !== 3 &&
                      currentTab != 'Pickup' && currentTab != 'Shipping' &&
                      currentTab != 'Completed' &&
                      currentTab != 'Hold' &&
                      data?.status !== 3 &&
                      canModifyTasks && (
                        <Stack
                          justifyContent="flex-end"
                          alignItems="center"
                          flexDirection="row"
                        >
                          <Card>
                            <Stack
                              justifyContent="flex-end"
                              alignItems="center"
                              flexDirection="row"
                              sx={{ m: 2 }}
                            >
                              <Stack
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="row"
                                sx={{ mr: 2 }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    textAlign: 'center',
                                    color: theme.palette.secondary,
                                  }}
                                >
                                  {'Date'}{' '}
                                </Typography>
                                <Typography
                                  variant="h5"
                                  sx={{
                                    textAlign: 'center',
                                    color: theme.palette.secondary,
                                  }}
                                >
                                  {moment().format('MM/DD/YYYY')}
                                </Typography>
                              </Stack>
                              {/* <Stack
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                              >
                                <Typography
                                  variant="h6"
                                  sx={{ textAlign: 'center', color: '#fc8c03' }}
                                >
                                  {'Work Time'}{' '}
                                </Typography>
                                {isLoggedIn ? (
                                  // (elapsedTime!==0) ?
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      textAlign: 'center',
                                      color: '#fc8c03',
                                    }}
                                  >
                                    {hours + ':' + minutes + ':' + seconds}
                                  </Typography>
                                ) : (
                                  // :
                                  // <Stack sx={{mr:2,textAlign: 'center',mb: 2}}>
                                  //   <CircularProgress color="warning" variant="indeterminate" size='20px' />
                                  // </Stack>
                                  <Typography
                                    variant="h4"
                                    sx={{
                                      textAlign: 'center',
                                      color: '#fc8c03',
                                    }}
                                  >
                                    {'00:00:00'}
                                  </Typography>
                                )}
                              </Stack> */}
                              {/* {
                                (checkedItems?.length > 0 || details?.project_category == 12) ?
                                    <Button variant='outlined' onClick={() => handleClockinTime()}>Work Time</Button> :
                                  ''
                              }  */}
                            </Stack>
                          </Card>
                          {/* <Button
                            variant="contained"
                            type="submit"
                            disabled={isSelectAll}
                            // onClick={() => {
                            //   handleClockInOut()
                            // }}
                            onClick={()=>{
                              if(isLoggedIn || checkedTaskDetails[0]?.service_id != null){
                                handleClockInOut()
                              }else{
                                if (checkedItems?.length > 0) {
                                  setOpenService(true)
                                } else {
                                  enqueueSnackbar("Please select a task", { variant: 'error' })
                                }
                              }
                            }}
                            sx={{ mb: 2, ml: 2 }}
                            startIcon={
                              <Stack>
                                {isLoggedIn ? <Logout /> : <Login />}
                              </Stack>
                            }
                          >
                            {isLoggedIn ? 'Clock Out' : 'Clock In'}
                          </Button> */}
                        </Stack>
                      )}
                  </Stack>
                )}
              </Box>
            ) : (
            <Box sx={{ width: '100%' }}>
              {user.user_type !== 3 &&
                currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                currentTab != 'Completed' &&
                !isMirrored &&
                currentTab != 'Hold' &&
                data?.status !== 3 &&
                !isEstimateJob &&
                canModifyTasks && hasJobCostPermission && (
                  <Stack
                    justifyContent="space-between"
                    alignItems="center"
                    // flexDirection="row"
                    flexDirection={isSmallScreen ? 'column' : 'row'}

                    sx={{ mb: 2, mt: 2, pl: 5 }}
                  >
                    <Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{ mb: 2 }} >
                      <TextField
                        size='small'
                        type="number"
                        label={'Enter Qty'}
                        placeholder='Enter Qty'
                        value={qty || ''}
                        inputProps={{ min: 0.01, step: "any" }}
                        onChange={(e) => {
                          setQty(e.target.value);
                        }}
                        onBlur={(e) => {
                          let val = Number(e.target.value);
                          if (e.target.value === '' || isNaN(val) || val <= 0) {
                            setQty(1);
                          } else {
                            setQty(val);
                          }
                        }}
                        onKeyDown={(event) => {
                          if (event.key === '-' || event.key === '+') {
                            event.preventDefault();
                          }
                        }}
                        onWheel={(e) => {
                          e.target.blur()
                          e.preventDefault()
                        }}
                      />

                      <TextField
                        size='small'
                        fullWidth
                        label={'Scan Product'}
                        placeholder="Scan Product"
                        value={searchMaterial}
                        onChange={(e) => {
                          setSearchMaterial(e.target.value)
                          handleAddMaterialToJobCost(e.target.value)
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Stack>
                    <Stack justifyContent='space-between' alignItems='center' flexDirection='row' gap={2} sx={{ mb: 2 }} >
                      <>
                        {/* Icon Button to trigger QR scanner */}
                        {/* QR Code Scanner Icon */}
                        <IconButton onClick={() => setOpenQRScanner(true)}>
                          <QrCodeScanner sx={{ fontSize: "30px" }} />
                        </IconButton>

                        {/* Dialog for QR Scanner */}
                        <Dialog open={openQRScanner} onClose={() => setOpenQRScanner(false)}>
                          <DialogTitle>Scan QR Code</DialogTitle>
                          <DialogContent>
                            <div id="reader" style={{ width: "100%" }}></div>
                          </DialogContent>
                        </Dialog>
                      </>
                      {/* <Tooltip title='View Added Materials'>
                        <Button
                          variant="contained"
                          sx={{ width: '200px' }}
                          type="submit"
                          onClick={() => {
                            handleViewAddedMaterials()
                            setViewMaterial(true)
                          }}
                          startIcon={
                            <Stack>
                              <Visibility />
                            </Stack>
                          }
                        >
                          View Materials
                        </Button>
                      </Tooltip> */}
                    </Stack>
                  </Stack>
                )}
              {data?.length > 0 && (
                <Stack
                  justifyContent="space-between"
                  alignItems="center"
                  flexDirection="row"
                >
                  <Stack
                    justifyContent="flex-start"
                    alignItems="center"
                    flexDirection="row"
                  >
                    <Typography variant="subtitle1">
                      {checkedItems?.length > 0 &&
                        checkedItems?.length + ' selected'}
                    </Typography>
                  </Stack>
                  {user.user_type !== 3 &&
                    currentTab != 'Installs' && currentTab != 'Pickup' && currentTab != 'Shipping' &&
                    currentTab != 'Completed' &&
                    currentTab != 'Hold' &&
                    data?.status !== 3 &&
                    !isEstimateJob &&
                    canModifyTasks && (
                      <Stack
                        justifyContent="flex-end"
                        alignItems="center"
                        flexDirection="row"
                      >
                        <Card>
                          <Stack
                            justifyContent="flex-end"
                            alignItems="center"
                            flexDirection="row"
                            sx={{ m: 2 }}
                          >
                            <Stack
                              justifyContent="center"
                              alignItems="center"
                              flexDirection="row"
                              sx={{ mr: 2 }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  textAlign: 'center',
                                  color: theme.palette.secondary,
                                }}
                              >
                                {'Date'}{' '}
                              </Typography>
                              <Typography
                                variant="h5"
                                sx={{
                                  textAlign: 'center',
                                  color: theme.palette.secondary,
                                }}
                              >
                                {moment().format('MM/DD/YYYY')}
                              </Typography>
                            </Stack>
                            {/* {
                              checkedItems?.length > 0 ?
                                <Button variant='outlined' onClick={() => handleClockinTime()}>Work Time</Button> :
                                ''
                            } */}
                          </Stack>
                        </Card>
                      </Stack>
                    )}
                </Stack>
              )}
            </Box>
            )}
            {displayTasks?.map((post, index) =>{ 
              return (
              <Grid
                key={index}
                item
                xs={12}
                sm={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  px: { xs: 0.75, sm: 2 },
                  pb:{xs:1,sm:2,md:3}
                }}
              >
                {getProjectTaskCardJsx(post, false)}
                <ConfirmationPopup
                  open={deleteStates[post.ID]}
                  handleClick={() => handleDeleteTask(post.ID, projectId)}
                  message={'Want to Delete This Task'}
                  handleClose={() => handleCancelDelete(post.ID)}
                />
                <ConfirmationPopup
                  open={confirmAdditionalJObCost}
                  handleClick={() => handleConfirmAdditionalJobCost()}
                  message={confirmMessage}
                  handleClose={() => {
                    setConfirmAdditionalJObCost(false)
                    setConfirmMessage('')
                    setSearchMaterial('')
                  }}
                />
                <WarningMaterialPopup
                  open={warningMaterialPopup}
                  onClose={handleWarningClose}
                  onConfirm={handleWarningConfirm}
                  materialName={warningMaterialData?.name || 'Material'}
                  qty={qty || 1}
                  // partialCondition={partialCondition}
                  partialCondition={warningMaterialData?.partial===1? qty>1 ? true:false:partialCondition}
                  addPartialStock={addPartialStock}
                  setAddPartialStock={setAddPartialStock}
                />


<ConfirmationPopup
                    isComplete={true}
                      open={openPopupComplete}
                      setCompleteStatus={setCompleteStatus}
                      noServiceNoTask={details?.noServiceNoTask}
                      projectCategory={projectData?.project_category}
                      projectId={projectId}
                      projectTasks={data}
                      handleClick={(stockData) => {
                        if(finalTaskStatus == 9){ //if from delete
                          convertJObToInstallation(stockData)
                        }else{
                          handleFinalUpdateStatus(stockData)
                        }
                      }}
                       hideCancel={true}
                    />

              </Grid>
            )})}

            <Dialog
              open={bundleStackModalPost != null}
              onClose={() => setBundleStackModalPost(null)}
              maxWidth="lg"
              fullWidth
              scroll="body"
            >
              <DialogTitle disableTypography sx={{ py: 2, px: 3, pr: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    gap: 2,
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 600, flex: 1, minWidth: 0, pr: 1 }}>
                  {bundleStackModalPost?.parent_product_name || bundleStackModalPost?.name
                    ? `${bundleStackModalPost?.parent_product_name || bundleStackModalPost?.name}`
                    : 'Bundle tasks'}
                  </Typography>
                  <IconButton
                    aria-label="Close"
                    onClick={() => setBundleStackModalPost(null)}
                    size="small"
                    sx={{ flexShrink: 0, ml: 'auto' }}
                  >
                    <Close />
                  </IconButton>
                </Box>
              </DialogTitle>
              <DialogContent dividers sx={{ pt: 2, pb: 2.5, px: 2, bgcolor: 'background.default' }}>
                <Grid container spacing={2} justifyContent="flex-start">
                  {bundleStackModalPost != null &&
                    [bundleStackModalPost, ...(bundleStackModalPost.linked_tasks || [])].map((task) => (
                      <Grid item xs={12} sm={6} md={4} key={task.ID ?? task.id} sx={{ display: 'flex', py: 0.5 }}>
                        {getProjectTaskCardJsx(task, true)}
                        <ConfirmationPopup
                          open={deleteStates[task.ID]}
                          handleClick={() => handleDeleteTask(task.ID, projectId)}
                          message={'Want to Delete This Task'}
                          handleClose={() => handleCancelDelete(task.ID)}
                        />
                      </Grid>
                    ))}
                </Grid>
              </DialogContent>
            </Dialog>

<ConfirmationPopup
                  open={confirmAdditionalJObCost}
                  handleClick={() => handleConfirmAdditionalJobCost()}
                  message={confirmMessage}
                  handleClose={() => {
                    setConfirmAdditionalJObCost(false)
                    setConfirmMessage('')
                    setSearchMaterial('')
                  }}
                  projectCategory={details?.project_category}
                  futureInstallations={futureInstallations}
                  existingJobCostData={existingJobCostData}
                  includeChooseInstallation ={details?.project_category !== 12}
                  selectedInstallation={selectedInstallation}
                  setSelectedInstallation={setSelectedInstallation}
                />
                
               <WarningMaterialPopup
                  open={warningMaterialPopup}
                  onClose={handleWarningClose}
                  onConfirm={handleWarningConfirm}
                  materialName={warningMaterialData?.name || 'Material'}
                  partialCondition={warningMaterialData?.partial===1? qty>1 ? true:false:partialCondition}
                  qty={qty || 1}
                  projectCategory={details?.project_category}
                  futureInstallations={futureInstallations}
                  existingJobCostData={existingJobCostData}
                  includeChooseInstallation ={details?.project_category !== 12}
                  selectedInstallation={selectedInstallation}
                  setSelectedInstallation={setSelectedInstallation}
                  addPartialStock={addPartialStock}
                  setAddPartialStock={setAddPartialStock}
                />

          </Grid>
          <Modal
            open={viewMaterial ? true : false}
            handleClose={() => {
              setViewMaterialData([])
              setViewMaterial(false)
            }}
            modalTitle={'Materials added'}
          >
            {loadingMaterials ? (
              <CircularProgress color="primary" variant="indeterminate" />
            ) : viewMaterialData?.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Barcode</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Unit Cost</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {viewMaterialData?.map((material, index) => (
                      <TableRow key={material.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{material.barcode}</TableCell>
                        <TableCell>{material.productName}</TableCell>
                        <TableCell>{material.unit_price}</TableCell>
                        <TableCell>{material.quantity}</TableCell>
                        <TableCell>{parseFloat(material.unit_price * material.quantity).toFixed(2)}</TableCell>
                        {/* <TableCell>{material.total}</TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>No materials added</Typography>
            )}
          </Modal>

          <ConfirmationPopup
            open={openPartialConfirm}
            message={`You want to move ${(partialTargetProduct?.name || partialTargetProduct?.product_name || 'this product')} to partial!`}
            handleClose={() => setOpenPartialConfirm(false)}
            handleClick={handleMoveToPartialFromWarning}
          />

          <Modal
            modalTitle={`Move ${partialTargetProduct?.partial==1 ? "Partial" : "Finished"} Product to Partial`}
            open={partialModalOpen}
            handleClose={handleClosePartialModal}
          >
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={8}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  {/* <Typography variant="body1" color={'red'}>Maximum Partial product qty: {partialTargetProduct?.partial==1 ? qty : partialTargetProduct?.ogRemainingQty ?? partialTargetProduct?.qty ?? 0}</Typography> */}
                {partialTargetProduct?.partial==0 &&<Typography variant="body1" color={'red'}>Maximum Partial product qty: {partialTargetProduct?.ogRemainingQty ?? partialTargetProduct?.qty ?? 0}</Typography>}
                    <TextField
                      fullWidth
                      label={`${convertionUnitName} Qty to be moved`}
                      type="number"
                      onKeyPress={(event) => {
                        if (event.key === '0' && event.target.value === '0') {
                          event.preventDefault()
                        }
                        if (event.key === '-' || event.key === '+' || event.key === 'e') {
                          event.preventDefault()
                        }
                      }}
                      disabled={partialTargetProduct?.partial==1 ? true:false}
                      inputProps={{ style: partialTargetProduct?.partial==1 ? { WebkitTextFillColor: 'rgba(255,255,255,0.38)', color: 'rgba(255,255,255,0.38)' } : {} }}
                      onWheel={(e) => {
                        e.target.blur()
                        e.preventDefault()
                      }}
                      value={partialTargetProduct?.partial==1 ?partialTargetProduct?.ogRemainingQty : movingQty}
                      onChange={(e) => {
                        // const maxremQty = partialTargetProduct?.partial==1 ? Number(partialTargetProduct?.ogRemainingQty) : Number(partialTargetProduct?.remainingQty)
                        const maxremQty = partialTargetProduct?.partial==1 ? Number(partialTargetProduct?.remainingQty): Number(partialTargetProduct?.remainingQty)
                        // const maxQty = maxremQty - qty;
                        const maxQty = maxremQty;
                        let inputQty = e.target.value || 1
                        if (partialTargetProduct?.partial==1 ? Number(inputQty) < 0 : Number(inputQty) < 1) {
                          inputQty = 1
                        }
                        if (maxQty > 0 && Number(inputQty) > maxQty) {
                          inputQty = maxQty
                        }
                        setMovingQty(inputQty)
                        // Set Conversion Qty to match Qty to be moved
                        setConvertionQty(inputQty)
                        const baseUnitCost = Number(
                          partialTargetProduct?.unit_cost ??
                            partialTargetProduct?.material_unit_cost ??
                            partialTargetProduct?.unit_price ??
                            partialTargetProduct?.unitPrice ??
                            0
                        )
                        // const unitCost = inputQty > 0 ? baseUnitCost / inputQty : 0
                        const unitCost = inputQty > 0 ? partialTargetProduct?.partial==1 ? baseUnitCost : (baseUnitCost / partialTargetProduct?.qtyForPrice) : 0
                        setConvertionUnitPrice(unitCost)
                        setConvertionTotalPrice(unitCost * inputQty)
                        setPartialErrors((prev) => ({ ...prev, movingQty: '' }))
                      }}
                      error={!!partialErrors.movingQty}
                      helperText={partialErrors.movingQty}
                    />

                    <TextField
                      fullWidth
                      label="Size"
                      type="text"
                      value={partialSize}
                      onChange={(e) => setPartialSize(e.target.value)}
                    />

                    <Autocomplete
                      fullWidth
                      id="partial-conversion-unit"
                      options={unitType ? UNITS.filter(unit => unit.id === unitType) : UNITS}
                      value={unitType ? UNITS.find(unit => unit.id === unitType) : convertionUnit}
                      onChange={(event, newValue) => {
                        setConvertionUnit(newValue)
                        setPartialErrors((prev) => ({ ...prev, convertionUnit: '' }))
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          error={!!partialErrors.convertionUnit}
                          helperText={partialErrors.convertionUnit}
                          label="Select a conversion unit"
                        />
                      )}
                      getOptionLabel={(option) => (option.name ? option.name : '')}
                    />
                    {/* <TextField
                      fullWidth
                      label={convertionUnit ? `${convertionUnit?.short_name} Qty` : 'Conversion Qty'}
                      type="number"
                      onKeyPress={(event) => {
                        if (event.key === '0' && event.target.value === '0') {
                          event.preventDefault()
                        }
                        if (event.key === '-' || event.key === '+' || event.key === 'e') {
                          event.preventDefault()
                        }
                      }}
                      value={convertionQty || ''}
                      onChange={(e) => {
                        const inputValue = parseFloat(e.target.value) || 0
                        const baseUnitCost = Number(
                          partialTargetProduct?.unit_cost ??
                            partialTargetProduct?.material_unit_cost ??
                            partialTargetProduct?.unit_price ??
                            partialTargetProduct?.unitPrice ??
                            0
                        )
                        const unitCost = inputValue > 0 ? baseUnitCost / inputValue : 0
                        setConvertionQty(inputValue)
                        setConvertionUnitPrice(unitCost)
                        setConvertionTotalPrice(unitCost * inputValue)
                        setPartialErrors((prev) => ({ ...prev, convertionQty: '' }))
                      }}
                      error={!!partialErrors.convertionQty}
                      helperText={partialErrors.convertionQty}
                    /> */}

                    {/* <TextField
                      fullWidth
                      label={'Unit Cost'}
                      type="number"
                      disabled
                      value={convertionUnitPrice ? parseFloat(convertionUnitPrice || 0)?.toFixed(2) : 0}
                    /> */}

                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={autoFill}
                          onChange={(event) => setAutoFill(event.target.checked)}
                        />
                      }
                      label="Automate the process"
                    />
                  </Stack>

                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="submit" variant="contained" onClick={handleSubmitPartialFromWarning}>
                      Move to Partial
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleClosePartialModal}
                      sx={{ marginLeft: '10px' }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Modal>
        </>
      ) : valueTab === 'three' ? (
        <Box sx={{ width: '100%' }}>
          <ProjectViewList handleOpenTask={handleOpenTask} popupOn={popupOn || isSalesOrderVoided} handleDeleteTask={handleDeleteTask} data={displayTasks} details={details}  currentTab={currentTab}/>
        </Box>
      ) : (
        <Box sx={{ width: '100%' }}>
        <ProjectViewGridList
          designs={designs}
          handleDeleteTask={handleDeleteTask}
          data={displayTasks}
          handleOpenTask={handleOpenTask} popupOn={popupOn || isSalesOrderVoided}
          details={details}
          currentTab={currentTab}
        />
        </Box>
      )}

          <Dialog
            open={scheduleDialogOpen}
            onClose={() => {
              if (scheduleSubmitLoading) return
              handleCloseScheduleDialog()
            }}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Schedule install</DialogTitle>
            <DialogContent>
              <StaticDatePicker
                orientation="portrait"
                openTo="day"
                minDate={moment()}
                value={scheduleTarget?.is_scheduled == 1 ? moment.unix(Number(scheduleTarget?.schedule_date)).toDate() : scheduleDate.toDate()}
                onChange={(newValue) => newValue && setScheduleDate(moment(newValue))}
                showToolbar={false}
                components={scheduleStaticDatePickerComponents}
                sx={{
                  '& .Mui-selected': {
                    color: '#fff !important',
                  },
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseScheduleDialog} disabled={scheduleSubmitLoading}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitTaskSchedule}
                disabled={scheduleSubmitLoading}
                startIcon={
                  scheduleSubmitLoading ? (
                    <CircularProgress color="inherit" size={18} />
                  ) : null
                }
              >
                {scheduleTarget?.is_scheduled == 1 ? 'Reschedule' : 'Schedule'}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            aria-describedby="alert-dialog-slide-description"
            TransitionComponent={Transition}
            transitionDuration={500}
            open={openService}
            PaperProps={{
              sx: {
                width: { xs: '90%', sm: '60%', md: '70%' },
                p: 2,
                borderRadius: 2
              }
            }}
          >
            <DialogContent
              sx={{
                mt: 1,
                px: 2,
                overflowY: 'auto',
                overflowX: 'auto',
                scrollbarWidth: 'thin',
                '&::-webkit-scrollbar': {
                  width: '0.75rem',
                },
                '&::-webkit-scrollbar-track': {
                  boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
                  webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(110, 108, 108, 0.32)',
                  borderRadius: '4px',
                },
                maxHeight: 500,
              }}
            >
              <Table size="small" sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ width: '30%', py: 1 }}>
                      <strong>Member</strong>
                    </TableCell>
                    {/* <TableCell align="center" sx={{ width: '40%', py: 1 }}>
                      <strong>Service</strong>
                    </TableCell> */}
                    <TableCell align="center" sx={{ width: '25%', py: 1 }}>
                      <Box>
                        <Typography variant="subtitle2" fontWeight="bold">
                          Time
                        </Typography>
                        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                          (HH:MM)
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {subTaskMembers.map((item) => ( */}
                  {
                    (isAdminUser (userType) || userType === 8
                      ? subTaskMembers
                      : subTaskMembers.filter((item) => item.userId === userId)
                      ).length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No job members available
                        </TableCell>
                      </TableRow>
                      ) :
                    (isAdminUser (userType) || userType === 8
                      ? subTaskMembers
                      : subTaskMembers.filter((item) => item.userId === userId)
                    ).map((item) => (
                      <TableRow key={item.id} sx={{ mt: 1, height: 44 }}>
                        <TableCell align="center">{item.name}</TableCell>

                        {/* {checkedTaskDetails?.[0]?.service_id == null ? (
                                          <TableCell>
                                            <Autocomplete
                                              fullWidth
                                              size="small"
                                              options={filteredClockInServices}
                                              getOptionLabel={(option) => option.name}
                                              renderInput={(params) => (
                                                <TextField {...params} placeholder="Select service" size="small" />
                                              )}
                                              onChange={(event, newValue) => {
                                                updateClockInInput(item.staff_id, {
                                                  service_id: newValue?.id || null,
                                                  hourly_rate: item.hourly_rate,
                                                  userId: item.userId
                                                });
                                              }}
                                            />
                                          </TableCell>
                                        ):
                                          <TableCell>
                                          <Autocomplete
                                            fullWidth
                                            size="small"
                                            options={
                                              filteredClockInServices.find((opt) => opt.id === checkedTaskDetails?.[0]?.customer_order_product_id)
                                                ? filteredClockInServices.filter((opt) => opt.id === checkedTaskDetails?.[0]?.customer_order_product_id)
                                                : filteredClockInServices
                                            }
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                              <TextField {...params} placeholder="Select service" size="small" />
                                            )}
                                            onChange={(event, newValue) => {
                                              updateClockInInput(item.staff_id, {
                                                service_id: newValue?.id || null,
                                                hourly_rate: item.hourly_rate,
                                                userId: item.userId
                                              });
                                            }}
                                          />
                                        </TableCell>
                                        } */}

                        <TableCell>
                          {/* <TextField
                            // type="number"
                            label="Duration"
                            placeholder="e.g. 1:30 or 1.30.15"
                            size="small"
                            fullWidth
                            defaultValue={0}
                            inputProps={{ min: 0, step: 0.1 }}
                            sx={{ '& input': { textAlign: 'center' } }}
                            onKeyDown={(e) => {
                            const allowedKeys = [
                              'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                              '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                            ];

                          if (
                            !allowedKeys.includes(e.key) &&
                            !(e.key.length === 1 && allowedKeys.includes(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                            // onChange={(e) => {
                            //   const hour = parseFloat(e.target.value);
                            //   updateClockInInput(item.staff_id, {
                            //     hour,
                            //     hourly_rate: item.hourly_rate,
                            //     userId: item.userId
                            //   });
                            // }}
                            onChange={(e) => {
                              const input = e.target.value.trim();
                              const parts = input.split(/[:.]/).map((p) => parseInt(p || 0, 10));

                              let [h = 0, m = 0, s = 0] = parts;

                              // Validate ranges
                              if (isNaN(h)) h = 0;
                              if (isNaN(m) || m > 59) m = 0;
                              if (isNaN(s) || s > 59) s = 0;

                              const decimal = h + m / 60 + s / 3600;

                              const selectedServiceId =
                                checkedTaskDetails?.[0]?.service_id == null
                                  // ? filteredClockInServices?.[0]?.id || null
                                  ? filteredClockInServices.find(s => s.labour_cost_service_id !== 10)?.id || null
                                  : filteredClockInServices.find(opt => opt.id === checkedTaskDetails?.[0]?.customer_order_product_id)?.id || null;

                              updateClockInInput(item.staff_id, {
                                hour: decimal,
                                hourly_rate: item.hourly_rate,
                                userId: item.userId,
                                service_id: selectedServiceId
                              });
                            }}
                          /> */}
                          <Stack direction="row" spacing={1} justifyContent="center">
                            <TextField
                              name="hours"  
                              label="Hours"
                              placeholder="01"
                              size="small"
                              sx={{ width: 80 }}
                              inputProps={{ min: 0 }}
                              // defaultValue={0}
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const h = parseInt(e.target.value || '0', 10);
                                const m = parseInt(
                                  e.target.closest('tr').querySelector('input[name="minutes"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                details?.project_category == 12 ? 
                                clockInServices.find((s) => s.labour_cost_service_id == 10)?.id || null :
                                checkedTaskDetails?.[0]?.service_id == null
                                ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                : filteredClockInServices.find((opt) => opt.id === checkedTaskDetails?.[0].customer_order_product_id)?.id || null;
                                
                                console.log('selectedServiceId', selectedServiceId)
                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  hourly_rate: item.hourly_rate,
                                  userId: item.userId,
                                  service_id: selectedServiceId,
                                  staff_name : item.name
                                });
                              }}
                            />

                            <TextField
                              label="Minutes"
                              name="minutes"
                              placeholder="30"
                              size="small"
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
                                  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ':'
                                ];

                                if (
                                  !allowedKeys.includes(e.key) &&
                                  !(e.key.length === 1 && allowedKeys.includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              sx={{ width: 80 }}
                              inputProps={{ min: 0, max: 60 }}
                              // defaultValue={0}
                              onInput={(e) => {
                                const value = parseInt(e.target.value || '0', 10);
                                if (value > 60) {
                                  e.target.value = 60;
                                } else if (value < 0) {
                                  e.target.value = 0;
                                }
                              }}
                              onChange={(e) => {
                                let m = parseInt(e.target.value || '0', 10);
                                let h = parseInt(
                                  e.target.closest('tr').querySelector('input[name="hours"]')?.value || '0',
                                  10
                                );

                                const totalMinutes = h * 60 + m;
                                const decimal = Math.round((totalMinutes / 60) * 10000) / 10000;

                                const selectedServiceId =
                                  details?.project_category == 12 ? 
                                  clockInServices.find((s) => s.labour_cost_service_id == 10)?.id || null :
                                  checkedTaskDetails?.[0]?.service_id == null
                                    ? filteredClockInServices.find((s) => s.labour_cost_service_id !== 10)?.id || null
                                    : filteredClockInServices.find((opt) => opt.id === checkedTaskDetails?.[0].customer_order_product_id)?.id || null;

                                updateClockInInput(item.staff_id, {
                                  hour: decimal,
                                  hourly_rate: item.hourly_rate,
                                  userId: item.userId,
                                  service_id: selectedServiceId,
                                  staff_name : item.name
                                });
                              }}
                            />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>

              </Table>
            </DialogContent>

            <Stack direction="row" justifyContent="flex-end" spacing={2} px={3} mt={1} pb={2}>
              <Button
                onClick={() => {
                  handleClose();
                  enqueueSnackbar('Operation was cancelled', { variant: 'error' });
                }}
                sx={{
                  background: '#BB2525',
                  color: '#fff',
                  '&:hover': {
                    background: '#FF8F8F',
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={() => {
                  handleClockInOut()
                }
                }
                disabled={isClockInDisabled}
              >
                {loading2 ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Clock In'
                )}
              </Button>
            </Stack>
          </Dialog>

    {/* <ProjectStatusPopup open={openPopup} onClose={handleClosePopup} staffTimeLogData={staffTimeLog} handleClockInOut={handleClockInOut} autoClockoutTime={autoClockoutTime} /> */}
    
    {/* Service Workflow Confirmation Dialog */}
    <Dialog
      open={openServiceWorkflowConfirmation}
      onClose={() => setOpenServiceWorkflowConfirmation(false)}
      aria-labelledby="service-workflow-confirmation-dialog-title"
      aria-describedby="service-workflow-confirmation-dialog-description"
    >
      <DialogTitle id="service-workflow-confirmation-dialog-title">
        Confirm Task Completion
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="service-workflow-confirmation-dialog-description">
          The following task has no service workflow assigned:
        </DialogContentText>
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 'medium' }}>
            • {selectedTaskForCompletion?.name || `Task ${selectedTaskForCompletion?.ID}`}
          </Typography>
        </Box>
        <DialogContentText sx={{ mt: 2 }}>
          Are you sure you want to complete this task?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => setOpenServiceWorkflowConfirmation(false)}
          variant="outlined"
          color="error"
        >
          Cancel
        </Button>
        <Button 
          onClick={() => {
            setOpenServiceWorkflowConfirmation(false);
            handleUpdateStatus(3, selectedTaskForCompletion.ID, selectedTaskForCompletion.project_id);
          }}
          variant="contained"
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
    
    {/* PDF Modal Dialog */}
    <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
      <Card sx={{ padding: 3, maxWidth: 768, margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (isClient || userType === 3) {
                // For clients/userType 3: Open PDF in new window without toolbar
                const newWindow = window.open('', '_blank');
                newWindow.document.write(`
                  <html>
                    <head>
                      <title>PDF Viewer</title>
                      <style>
                        body { margin: 0; padding: 0; overflow: hidden; }
                        iframe { width: 100vw; height: 100vh; border: none; }
                      </style>
                    </head>
                    <body>
                      <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                    </body>
                  </html>
                `);
                newWindow.document.close();
              } else {
                // For other users: Open PDF normally
                window.open(selectedPDF, '_blank');
              }
            }}
            disabled={!selectedPDF}
            startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
            sx={{
              fontSize:'14px'
            }}
          >
            View PDF
          </Button>
        </div>
        {pdfLoading && (
          <Skeleton variant="rectangular" width="100%" height={500} />
        )}

        {(isClient || userType === 3) && useOfficeViewer ? (
          <iframe
            src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
            title="Selected PDF"
            width="100%"
            height="500px"
            frameBorder="0"
            style={{ display: pdfLoading ? 'none' : 'block' }}
            onLoad={() => setPdfLoading(false)}
            onError={() => {
              // If Google Docs viewer fails, fallback to direct iframe
              setUseOfficeViewer(false);
              setPdfLoading(false);
            }}
          />
        ) : (
          <iframe
            src={selectedPDF}
            title="Selected PDF"
            width="100%"
            height="500px"
            frameBorder="0"
            style={{ display: pdfLoading ? 'none' : 'block' }}
            onLoad={() => setPdfLoading(false)}
          />
        )}
      </Card>
    </DialogAnimate>
    </>
  )
}
